webpackJsonp([1],{

/***/ "50TW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_common_vue_src_lib_Api__ = __webpack_require__("MnUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BaseComponent__ = __webpack_require__("q0ey");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// 最大文字数
var MAX_LEN_ADDRESS = 50;
var MAX_LEN_NAME = 30;
var MAX_LEN_PRODUCT_ID = 50;
var MAX_LEN_DESCRIPTION = 1000;

// 必須項目ルール
var requiredRule = function requiredRule(v) {
  return !!v || '必須項目です。';
};

// 文字数ルール
var lengthRule = function lengthRule(len) {
  return function (v) {
    if (v === null) return true;
    return v.length <= len || len + '\u6587\u5B57\u307E\u3067\u3067\u3059\u3002';
  };
};

// 郵便番号ルール
var zipCodeRule = function zipCodeRule(v) {
  if (v === null) return true;
  var ok = v.length === 7 && /[0-9]{7}/.test(v) || v.length === 8 && /[0-9]{3}-[0-9]{4}/.test(v);
  return ok || '例：100-1000';
};

// 電話番号ルール
var telRule = function telRule(v) {
  if (v === null) {
    return true;
  }

  var example = '例：03-1234-5678';
  if (v.length > 13) {
    return example;
  }

  var pattern = v.indexOf('-') !== -1 ? /\d{2,5}-\d{1,4}-\d{4}/ : /\d{10,11}/;
  var matched = v.match(pattern);
  if (matched && matched[0] === v) {
    return true;
  } else {
    return example;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Repair',
  extends: __WEBPACK_IMPORTED_MODULE_2__components_BaseComponent__["a" /* default */],
  props: ['initProductId'],
  computed: {
    addressMaxLength: function addressMaxLength() {
      return MAX_LEN_ADDRESS;
    },
    nameMaxLength: function nameMaxLength() {
      return MAX_LEN_NAME;
    },
    productIdMaxLength: function productIdMaxLength() {
      return MAX_LEN_PRODUCT_ID;
    },
    descriptionMaxLength: function descriptionMaxLength() {
      return MAX_LEN_DESCRIPTION;
    }
  },
  data: function data() {
    return {
      formValid: true,

      // 入力ルール
      zipCodeRules: [requiredRule, zipCodeRule],
      address1Rules: [requiredRule, lengthRule(MAX_LEN_ADDRESS)],
      address2Rules: [lengthRule(MAX_LEN_ADDRESS)],
      nameRules: [requiredRule, lengthRule(MAX_LEN_NAME)],
      productIdRules: [requiredRule, lengthRule(MAX_LEN_PRODUCT_ID)],
      telRules: [requiredRule, telRule],
      descriptionRules: [requiredRule, lengthRule(MAX_LEN_DESCRIPTION)],

      // 入力データ
      zipCode: '',
      address1: '',
      address2: '',
      name: '',
      tel: '',
      productId: '',
      description: '',

      // 完了ダイアログ
      visibleCompletionDialog: false
    };
  },
  created: function created() {
    if (this.initProductId) {
      this.productId = this.initProductId;
    }
  },

  methods: {
    searchAddress: function searchAddress() {
      var _this = this;

      var search = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.zipaddress.net/', {
        params: {
          'zipcode': this.zipCode
        }
      });
      search.then(function (res) {
        var code = res.data.code;
        if (code === 200) {
          _this.address1 = res.data.data.fullAddress;
        } else if (code === 400) {
          alert('郵便番号の形式が正しくありません。');
        } else if (code === 404) {
          alert('住所が見つかりませんでした。');
        } else {
          alert('\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002(' + res.data.message + ')');
        }
      }).catch(function (err) {
        alert('\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002(' + err + ')');
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.$refs.form.validate()) return;

      var create = new __WEBPACK_IMPORTED_MODULE_1__app_common_vue_src_lib_Api__["a" /* default */]().createRepairRequest(this.getInputData());
      create.then(function (res) {
        _this2.visibleCompletionDialog = true;
        _this2.$refs.form.reset();
      }).catch(function (err) {
        console.log(err);
        alert('\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002(' + err + ')');
      });
    },
    getInputData: function getInputData() {
      return {
        'zip_code': this.zipCode,
        'address': this.address2 ? this.address1 + this.address2 : this.address1,
        'name': this.name,
        'tel': this.tel,
        'product_id': this.productId,
        'description': this.description
      };
    },
    finish: function finish() {
      if (this.currentUser) {
        this.$router.push({ name: 'Chat' });
      } else {
        this.$router.push({ name: 'Top' });
      }
    }
  }
});

/***/ }),

/***/ "5ZFJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


// メッセージ取得エラー後の再リクエスト最小間隔 (ミリ秒)
var RETRY_FETCH_MIN_INTERVAL = 3000;

// メッセージ取得エラー後の再リクエスト回数上限
var RETRY_FETCH_MAX_COUNT = 5;

/*
 * since_idパラメーターによるロングポーリング
 */

var LongPolling = function () {
  function LongPolling(api, url) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LongPolling);

    this.api = api;
    this.url = url;

    // 最終取得時刻 (ミリ秒)
    this.lastFetchedTimeInMillis = 0;

    // 取得エラー後の再リクエスト回数
    this.retryFetchCount = 0;

    // ロングポーリング開始済み
    this.started = false;

    // ロングポーリング停止要求 (stop()が呼ばれた後)
    this.stopRequested = false;

    // 取得済みレコードのid
    this.sinceId = null;

    // データ取得時のハンドラー (デフォルトはnoop関数)
    this.fetchHandler = function (data) {};

    this.errorHandler = function (data) {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LongPolling, [{
    key: 'start',


    /**
       * データを取得をループします。
     * 2回目以降はsince_idパラメーターにより最新データを待ちます。
       */
    value: function start() {
      if (this.started) return;

      console.log('Start: ' + this.url);
      this.started = true;
      this.fetch();
    }

    /**
     *
     */

  }, {
    key: 'fetch',
    value: function fetch() {
      var _this = this;

      if (this.stopRequested) {
        console.log('Stopped: ' + this.url);
        return;
      }

      var params = {};
      if (this.sinceId !== null) {
        params['since_id'] = this.sinceId;
        console.log('Waiting for new ' + this.url + ' modified since ' + this.sinceId);
      }

      this.lastFetchedTimeInMillis = Date.now();

      var get = this.api.request('GET', this.url, {
        params: params
      });
      get.then(function (res) {
        if (!_this.stopRequested) {
          _this.onFetchDone(res.data);
        }
      }).catch(function (err) {
        if (!_this.stopRequested) {
          _this.onFetchFail(err);
        }
      });
    }

    /**
       * 取得したデータをハンドラーへ渡します。
     * 最新メッセージ以降の新着メッセージをリクエストします。
       */

  }, {
    key: 'onFetchDone',
    value: function onFetchDone(data) {

      if (Array.isArray(data) && 0 < data.length) {
        var last = data[data.length - 1];
        this.sinceId = last.id;
        this.fetchHandler(data);
      } else if (data.id) {
        this.sinceId = data.id;
        this.fetchHandler(data);
      } else if (this.sinceId === null) {
        this.sinceId = 0;
        if (this.url.includes('/rooms/') && this.url.includes('/messages')) {
          // apiのurlに'/rooms/'と'/messages'が含まれている場合
          // 初回のmessage取得件数が0件であっても、読込アニメーション制御の為、ハンドラーへデータを渡す
          this.fetchHandler(data);
        }
      }

      this.fetch();
    }

    /**
     * データ取得に失敗した場合に呼ばれます。
     */

  }, {
    key: 'onFetchFail',
    value: function onFetchFail(err) {
      var _this2 = this;

      console.log(err);

      var elapsed = Date.now() - this.lastFetchedTimeInMillis;
      if (RETRY_FETCH_MIN_INTERVAL < elapsed) {
        // 正常な状態（サーバー起動中の状態におけるタイムアウト）のためリトライ回数は増やさない。
        this.fetch();
      } else {
        if (err.response && err.response.status === 403) {
          this.errorHandler(err);
          this.stop();
        }
        var interval = Math.max(RETRY_FETCH_MIN_INTERVAL - elapsed, 0);
        window.setTimeout(function () {
          return _this2.retryFetch();
        }, interval);
      }
    }

    /**
     * メッセージ取得をリトライします。
     * リトライ回数上限を超えた場合はalertを表示します。
     */

  }, {
    key: 'retryFetch',
    value: function retryFetch() {
      this.retryFetchCount += 1;
      if (RETRY_FETCH_MAX_COUNT < this.retryFetchCount) {
        // TODO エラーメッセージ
        window.alert('システムに問題が発生しています。');
      } else {
        this.fetch();
      }
    }

    /**
       * ロングポーリングを停止します。
     * 実行中のリクエストは最後まで実行されます。
       */

  }, {
    key: 'stop',
    value: function stop() {
      if (this.started && !this.stopRequested) {
        console.log('Stop requested: ' + this.url);
        this.stopRequested = true;
      }
    }
  }, {
    key: 'onFetch',
    set: function set(handler) {
      if (handler === null) {
        this.fetchHandler = function (data) {};
      } else {
        this.fetchHandler = handler;
      }
    }
  }, {
    key: 'onError',
    set: function set(handler) {
      if (handler === null) {
        this.errorHandler = function (data) {};
      } else {
        this.errorHandler = handler;
      }
    }
  }, {
    key: 'isStarted',
    get: function get() {
      return this.started;
    }
  }]);

  return LongPolling;
}();

/* harmony default export */ __webpack_exports__["a"] = (LongPolling);

/***/ }),

/***/ "5n3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserReg_vue__ = __webpack_require__("he8S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082ef383_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserReg_vue__ = __webpack_require__("LDsl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserReg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082ef383_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_UserReg_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6d20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TITLE = 'チャットでお問い合わせ';
// const TITLE = '自然言語対話AIエンジン'
var SUB_TITLE = 'ユーザーアプリ';

// visibilitychangeイベント用
var STATE_VISIBLE = 'visible';
var STATE_HIDDEN = 'hidden';

/* harmony default export */ __webpack_exports__["a"] = ({
  title: TITLE,
  subTitle: SUB_TITLE,
  stateVisible: STATE_VISIBLE,
  stateHidden: STATE_HIDDEN
});

/***/ }),

/***/ "AxbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_ChatMessages_ChatMessages_js__ = __webpack_require__("ELEq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eae819ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_ChatMessages_ChatMessages_pug__ = __webpack_require__("i6Ml");
function injectStyle (ssrContext) {
  __webpack_require__("TAaz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eae819ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_ChatMessages_ChatMessages_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eae819ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_ChatMessages_ChatMessages_pug__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CQE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app",
      "toolbar": ""
    }
  }, [_c('header-nav'), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var state = {
  user: JSON.parse(localStorage.getItem('user'))
};

var mutations = {
  onChangeCurrentUser: function onChangeCurrentUser(state, user) {
    state.user = user;
    localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
  }
};

var actions = {
  setCurrentUser: function setCurrentUser(_ref, user) {
    var commit = _ref.commit;

    var newUser = !user ? null : {
      id: user.user_id,
      name: user.user_name,
      accessToken: user.token
    };
    commit('onChangeCurrentUser', newUser);
  }
};

var getters = {
  currentUser: function currentUser(state) {
    return state.user;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "ELEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_Api__ = __webpack_require__("MnUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_ChatClient__ = __webpack_require__("TI0G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_Utils__ = __webpack_require__("ckiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_const__ = __webpack_require__("6d20");









var CLOSING_STATUSES = ['resolved', 'leave_timed_out', 'room_timed_out', 'calling_failed'];
var LOADING_TIME = 700;
var NEXT_FAQ_TIME = 500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChatMessages',
  props: ['room', 'senderId', 'senderName', 'senderType', 'isAfterBusinessHour', 'messageLoading', 'displayVisibilityState'],

  data: function data() {
    return {
      roomId: null,
      messages: [],
      productCategory: "",
      troubleCategory: "",
      initMessage: [],
      chatbotMessage: [],
      newRoomFlg: false,
      closedRoomFlg: false,
      newChatClick: false,
      messagesRead: '',
      frequentlyQuestionFlg: false,
      existFrequentlyQuestion: false,
      categoryValue: "",
      troubleCategoryValue: "",
      callOperatorFlg: false,
      existCallingOperator: false
    };
  },

  ///// options /////
  api: null,
  chatClient: null,

  created: function created() {
    var _this = this;

    // viewNewChatをOFFにする
    this.$emit("view-new-chat", false);

    this.$options.api = new __WEBPACK_IMPORTED_MODULE_4__lib_Api__["a" /* default */]();
    if (this.room) {
      this.$options.api.currentRoomStatus(this.room.id).then(function (res) {
        if (_this.room && res.data.length > 0) {
          _this.enterRoom(_this.room.id, _this.room.accessToken);
        } else {
          // 現在のルームが解決済みの場合は新規ルームを作成
          _this.createNewRoom();
        }
      }).catch(function (err) {
        window.alert('ネットワークが不安定な為、通信に時間がかかっています。', err);
      });
    } else {
      this.createNewRoom();
    }
    this.$options.chatClient.isWaitingResponse = false;
  },
  updated: function updated() {
    // 読込アニメーション表示中は処理を中断する
    if (this.messageLoading) return;
    this.$options.chatClient.isWaitingResponse = false;
    var height = __WEBPACK_IMPORTED_MODULE_3_jquery__(this.$refs.root).prop('offsetHeight');
    var productCodes = this.messages.filter(function (message) {
      return message.context === 'set-product-code';
    });
    if (productCodes.length > 0) {
      var latestProductCode = productCodes[productCodes.length - 1].content.product_code;
      this.productCode = latestProductCode;
    }
    var productCategories = this.messages.filter(function (message) {
      return message.context === 'set-product-category';
    });
    if (productCategories.length > 0) {
      this.$parent.productCategory = productCategories[productCategories.length - 1].content.question_category;
    }

    if (this.messages.length - 2 > 0) {
      if (this.messages[this.messages.length - 2].context === 'frequently-question' || this.messages[this.messages.length - 2].context === 'question') {
        // 最後のメッセージがよくある質問の場合はスクロールを調整する
        // context「frequently-question」「question」の要素のoffsetTopを取得して、スクロール位置を計算
        var chatmessagesTop = __WEBPACK_IMPORTED_MODULE_3_jquery__(this.$refs.root).offset().top;
        var targetElemntTop = __WEBPACK_IMPORTED_MODULE_3_jquery__(this.$refs.root).children().eq(this.messages.length - 1).offset().top;
        height = targetElemntTop - chatmessagesTop;
      }
    }

    this.$emit('update-messages', height);
  },
  beforeDestroy: function beforeDestroy() {
    this.stopFetch();
    this.$emit('stop-polling');
  },

  computed: {
    productCode: {
      get: function get() {
        this.$parent.productCode;
      },
      set: function set(value) {
        this.$emit('set-product-code', value);
      }
    }
  },
  watch: {
    room: function room(newRoom) {
      if (newRoom) {
        if (this.roomId !== newRoom.id) {
          this.stopFetch();
          this.$emit('stop-polling');
          this.messages = [];
          this.enterRoom(newRoom.id, newRoom.accessToken);
        } else {
          // no-op
        }
      } else {
        this.stopFetch();
        this.$emit('stop-polling');
        this.messages = [];
        this.newRoomFlg = true;
        this.newChatClick = true;
        this.createNewRoom();
        // botメッセージ内のボタン制御用フラグ
        this.closedRoomFlg = false;
        // botの固定メッセージ制御用フラグ
        this.frequentlyQuestionFlg = false;
        // botメッセージ制御用フラグ
        this.callOperatorFlg = false;
      }
    }
  },
  methods: {
    /*
     * 新規ルーム作成
     */
    createNewRoom: function createNewRoom() {
      var _this2 = this;

      var create = this.$options.api.createRoom();
      create.then(function (res) {
        var newRoom = res.data;
        console.log('New chat room: ' + newRoom.id);
        _this2.newRoomFlg = true;

        // this.$options.api.attachBot(newRoom);
        _this2.enterRoom(newRoom.id, newRoom.access_token);
      }).catch(function (err) {
        console.log(err);
        window.alert('チャットルームの作成に失敗しました。');
      });
    },
    enterRoom: function enterRoom(roomId, roomAccessToken) {
      this.roomId = roomId;
      this.$options.api.roomAccessToken = roomAccessToken;
      this.startFetchMessage(roomId);
      this.startFetchRoomState(roomId);
      this.$emit('enter-room', {
        roomId: roomId,
        roomAccessToken: roomAccessToken
      });

      // 最新滞在時間を通知
      this.$emit('create-notice-timer');
      if (this.newChatClick) {
        // 「新しいチャットを開始」にてルーム生成した場合
        // 営業時間、オペレーター空き状況のAPIを呼び出す
        this.$emit('reload-system-state');
      }
    },

    /*
     * 初期メッセージ表示
     */
    initialMessage: function initialMessage() {
      var now = new Date();
      return [{
        "id": 'initail-0',
        "version": "1.0",
        "type": "Text",
        "sender": __WEBPACK_IMPORTED_MODULE_5__lib_ChatClient__["a" /* default */].BOT_USER,
        "created_at": now,
        "content": {
          "text": "お問い合わせありがとうございます。\n\ 次の内容にご回答のうえ、お進みください。",
          "freetext_processible": false,
          "isLoading": true
        }
      }, {
        "id": 'initial-1',
        "version": "1.0",
        "type": "ProductCategorySelect",
        "sender": __WEBPACK_IMPORTED_MODULE_5__lib_ChatClient__["a" /* default */].BOT_USER,
        "created_at": now,
        "content": {
          "text": "次のうち、どの製品に関するお問い合わせですか？",
          "categories": [{ "value": "tv", "label": "テレビ" }, { "value": "bd", "label": "BD/DVD" }],
          "freetext_processible": false
        }
      }];
    },


    /*
     * メッセージ取得ロングポーリング開始
     */
    startFetchMessage: function startFetchMessage(roomId) {
      var _this3 = this;

      this.$options.chatClient = new __WEBPACK_IMPORTED_MODULE_5__lib_ChatClient__["a" /* default */](this.$options.api, roomId);
      this.$options.chatClient.sender = {
        id: this.senderId,
        name: this.senderName,
        role: this.senderType
        //ここに初期メッセージを追加
      };this.initMessage = this.initialMessage();

      if (this.newRoomFlg) {
        // 新規ルームの場合

        // viewNewChatをONにする
        this.$emit("view-new-chat", true);

        // メッセージ取得中のアニメーションが表示された状態で新しいチャットを選択された時を考慮した制御
        this.$emit("set-message-loading", false);

        this.messages.push(this.initMessage[0]);
        setTimeout(function () {
          // 1つ目のアニメーションOFFに変更後、2つ目のメッセージを挿入
          _this3.messages[0].content.isLoading = false;
          _this3.messages.push(_this3.initMessage[1]);
        }, LOADING_TIME);
      } else {
        // 既存ルームの場合
        // メッセージ取得中のアニメーションをONにする
        this.$emit("set-message-loading", true);
      }

      this.$options.chatClient.onFetchMessage = function (newMessages) {
        if (!_this3.newRoomFlg && _this3.messageLoading) {
          // 既存ルーム、メッセージ取得アニメーションがONの場合
          // メッセージ取得中のアニメーションをOFFにする
          _this3.$emit("set-message-loading", false);
          // 初期メッセージをthis.messagesに挿入する
          _this3.initMessage[0].content.isLoading = false;
          _this3.messages = _this3.initMessage;

          // viewNewChatをONにする
          _this3.$emit("view-new-chat", true);
        }

        // 既読情報の設定
        if (_this3.displayVisibilityState === __WEBPACK_IMPORTED_MODULE_7__util_const__["a" /* default */].stateVisible) {
          // 画面表示中の場合
          // 非表示時は既読更新しないようにする
          _this3.$options.api.updateReadDisplay(roomId).catch(function (err) {
            console.log(err);
          });
        }
        _this3.existFrequentlyQuestion = newMessages.some(function (element) {
          return element.context === "frequently-question";
        });

        _this3.existCallingOperator = newMessages.some(function (element) {
          return element.context === "calling-operator";
        });
        if (newMessages.length > 0) {
          // メッセージが1件でも取得できた場合
          // ロードアニメーション制御フラグをbotメッセージに追加する
          var editMessages = [];
          editMessages = _this3.setLoadingFlg(newMessages);

          // 通常時は1秒後にロードアニメーションをOFFにするタイマーをセットする
          if (editMessages.length === 1 || editMessages.length === 2 && _this3.existFrequentlyQuestion || editMessages.length === 2 && _this3.existCallingOperator) {
            setTimeout(function () {
              _this3.messages.forEach(function (message) {
                if (message.content.isLoading) {
                  message.content.isLoading = false;
                }

                if (!_this3.frequentlyQuestionFlg && message.context == 'frequently-question') {
                  _this3.frequentlyQuestionFlg = true;
                }
                if (!_this3.callOperatorFlg && message.context == "calling-operator") {
                  _this3.callOperatorFlg = true;
                }
              });
            }, LOADING_TIME);
          } else {
            if (!_this3.frequentlyQuestionFlg && _this3.existFrequentlyQuestion > 0) {
              _this3.frequentlyQuestionFlg = true;
            }
            if (!_this3.callOperatorFlg && _this3.existCallingOperator) {
              _this3.callOperatorFlg = true;
            }
          }
          _this3.$emit('fetch-new-messages', editMessages);
        }
      };
      this.$options.chatClient.startFetchMessage();
    },

    /*
     * ロードアニメーション制御フラグを追加
     */
    setLoadingFlg: function setLoadingFlg(newMessage) {
      var _messages;

      var returnMessage = newMessage;
      if (newMessage.length === 1 || newMessage.length === 2 && this.existFrequentlyQuestion || newMessage.length === 2 && this.existCallingOperator) {
        returnMessage = newMessage.map(function (value) {
          if (value.sender.role === "bot") {
            if (value.type === "secondText") return value;
            if (value.context === "calling-operator-second") return value;
            value.content["isLoading"] = true;
          }
          return value;
        });
      }

      // 「次の5件」用のアニメーション制御フラグを追加
      returnMessage = returnMessage.map(function (value) {
        value.content["faqIsLoading"] = false;
        return value;
      });

      // 編集したメッセージを画面表示用のデータに追加する
      (_messages = this.messages).push.apply(_messages, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(returnMessage));

      return returnMessage;
    },

    /*
     * メッセージ取得ロングポーリング開始
     */
    startFetchRoomState: function startFetchRoomState(roomId) {
      var _this4 = this;

      console.log(this.room);
      this.$options.chatClient = new __WEBPACK_IMPORTED_MODULE_5__lib_ChatClient__["a" /* default */](this.$options.api, roomId);
      this.$options.chatClient.sender = {
        id: this.senderId,
        name: this.senderName,
        role: this.senderType
      };
      this.$options.chatClient.onFetchRoomState = function (res) {
        if (res.state == "op_responding" || res.state == "sv_responding") {
          // メッセージ既読状態取得ポーリング開始
          _this4.$emit('start-polling');
        }
        if (!CLOSING_STATUSES.includes(res.state)) return;
        console.log("The chat was closed");
        _this4.$emit('chat-is-closed');
        // botメッセージ内のボタン制御用フラグ
        _this4.closedRoomFlg = true;
      };
      this.$options.chatClient.onErrorRoomState = function (err) {
        console.log(err);
        console.log("The chat was closed");
        _this4.$emit('chat-is-closed');
        // botメッセージ内のボタン制御用フラグ
        _this4.closedRoomFlg = true;
      };
      this.$options.chatClient.startFetchRoomState();
    },

    stopFetch: function stopFetch() {
      if (this.$options.chatClient) {
        this.$options.chatClient.stopFetch();
      }
    },

    isButtonSelected: function isButtonSelected(label, index) {
      var nextKey = index + 1;
      var nextMessage = this.messages[nextKey];
      if (!nextMessage) return false;

      return nextMessage.content.text == label;
    },


    /*
     * アニメーション後に表示するメッセージ
     */
    loadingDisplayMessageText: function loadingDisplayMessageText(msg) {
      if (msg.type === 'Text' && !msg.content.isLoading && msg.context != 'frequently-question-second' && msg.context != 'calling-operator-second') return true;
      if (msg.context === 'frequently-question-second' && this.frequentlyQuestionFlg) return true;
      if (msg.context === 'calling-operator-second' && this.callOperatorFlg) return true;
      return false;
    },

    /*
     * メッセージテキスト
     */
    displayMessageText: function displayMessageText(msg) {
      var text = msg.content.text;
      return __WEBPACK_IMPORTED_MODULE_6__lib_Utils__["a" /* default */].prepareLongTextValue(text);
    },

    /*
     * メッセージ送信者名
     */
    displaySenderName: function displaySenderName(sender) {
      if (sender.name) return sender.name;
      if (sender.id) return sender.id;
      if (sender.role) return sender.role;
      return '';
    },

    /*
     * メッセージroomID
     */
    displayMessageRoomId: function displayMessageRoomId(role) {
      if (role !== 'user') return;
      return "(ID:" + this.roomId + ")";
    },

    /*
     * チャット上のボタン押下 (userユーザーのみ)
     */
    onClickButton: function onClickButton(type, btn) {

      if (this.senderType !== 'user') return;

      if (this.$options.chatClient) {
        this.$emit("set-message-loading", true);
        this.$options.chatClient.sendButtonClick(type, btn);
      }
    },

    /*
     * FAQ後の判定ボタン押下 (userユーザーのみ)
     */
    onClickAnswerFeedbackButton: function onClickAnswerFeedbackButton(event) {
      if (this.$options.chatClient.isWaitingResponse) return;
      if (this.senderType !== 'user') return;

      var resolveStatus = event.target.parentElement.value === "true";
      var label = event.target.innerText;
      if (!this.$options.chatClient) return;

      if (!resolveStatus) {
        // 「解決しなかった」が選択された場合、営業時間を取得し直す
        this.$emit("set-business-hours");
      }
      this.$emit("set-message-loading", true);
      this.$options.chatClient.sendAnswerFeedback(label, resolveStatus);
    },


    /*
     * 固定FAQ後の判定ボタン押下 (userユーザーのみ)
     */
    onClickFrequentlyQuestionAnswerFeedbackButton: function onClickFrequentlyQuestionAnswerFeedbackButton(event) {
      if (this.$options.chatClient.isWaitingResponse) return;
      if (this.senderType !== 'user') return;

      var resolveStatus = event.target.parentElement.value === "true";
      var label = event.target.innerText;
      if (!this.$options.chatClient) return;

      this.$emit("set-message-loading", true);
      this.$options.chatClient.sendAnswerFrequentlyQuestionFeedback(label, resolveStatus);
    },


    // 製品選択ボタン押下
    onClickProduct: function onClickProduct(product) {
      if (this.senderType !== 'user') return;

      if (this.$options.chatClient) {
        this.$emit("set-message-loading", true);
        this.$options.chatClient.sendProductSelect(product.id, product.name);
      }
    },
    onClickProductCategory: function onClickProductCategory(category) {
      if (this.senderType !== 'user') return;

      this.$parent.productCategory = category;
      this.$parent.rawProductCode = '';
      if (!this.$options.chatClient) return;
      if (this.$options.chatClient.isWaitingResponse) return;

      this.$emit("set-message-loading", true);
      this.$options.chatClient.sendProductCategory(category);
    },
    onClickTroubleCategory: function onClickTroubleCategory(category) {
      if (this.senderType !== 'user') return;
      this.$parent.troubleCategory = category;
      if (!this.$options.chatClient) return;
      if (this.$options.chatClient.isWaitingResponse) return;

      this.$emit("set-message-loading", true);
      this.$options.chatClient.sendTroubleCategory(category, this.$parent.productCategory);
    },
    onClickAnswerCard: function onClickAnswerCard(answer) {
      window.open(answer.url);
    },
    onClickFaqPageLink: function onClickFaqPageLink() {
      var target = '';
      var category = this.$parent.productCategory;
      switch (category) {
        case 'tv':
          target = 'https://faq-cs.regza.com/faq/tv/faqList';
          break;
        case 'bd':
          target = 'https://faq-cs.regza.com/faq/bdDvd/faqList';
          break;
        default:
          target = 'https://faq-cs.regza.com/faq/tv/faqList';
          break;
      }
      window.open(target);
    },
    onClickAskFrequentlyFaqChatbot: function onClickAskFrequentlyFaqChatbot(event) {
      if (this.senderType !== 'user') return;
      if (!this.$options.chatClient) return;
      if (this.$options.chatClient.isWaitingResponse) return;

      var label = event.target.innerText;
      this.$emit("set-message-loading", true);
      this.categoryValue = this.$parent.productCategory;
      this.troubleCategoryValue = this.$parent.troubleCategory.value;
      this.$options.chatClient.sendRequestFrequentlyFaqChatbot(label, this.categoryValue, this.troubleCategoryValue);
    },
    onClickAskChatbot: function onClickAskChatbot(event) {
      if (this.senderType !== 'user') return;
      if (!this.$options.chatClient) return;
      if (this.$options.chatClient.isWaitingResponse) return;

      var label = event.target.innerText;
      this.$emit("set-message-loading", true);
      this.$options.chatClient.sendRequestFaqChatbot(label);
    },
    onClickSubmitProductCode: function onClickSubmitProductCode() {
      if (this.senderType !== 'user') return;
      if (!this.$options.chatClient) return;
      if (this.$options.chatClient.isWaitingResponse) return;
      console.log(this.$parent.productCode);
      this.$emit("set-message-loading", true);
      var category = this.$parent.productCategory;
      this.$options.chatClient.sendProductCode(this.$parent.productCode, category);
    },


    // 製品比較テーブルのヘッダー
    createProductCompareHeaders: function createProductCompareHeaders(products) {
      var headers = [{
        text: '仕様',
        value: 'prop_name',
        sortable: false,
        align: 'left'
      }];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(products), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var product = _step.value;

          headers.push({
            text: product.product_name,
            value: product.product_id,
            sortable: false,
            align: 'left'
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return headers;
    },


    // 製品比較テーブルの行
    createProductCompareItems: function createProductCompareItems(specs) {
      return specs.map(function (spec) {
        var item = {
          prop_name: spec.name,
          prop_url: spec.url
        };
        for (var productId in spec.values) {
          item[productId] = spec.values[productId];
        }
        return item;
      });
    },


    // 画像添付メッセージか否か
    messageIsImageFile: function messageIsImageFile(msg) {
      if (msg.type !== 'File') return false;
      if (!msg.content.file) return false;
      if (!msg.content.file.type) return false;

      return msg.content.file.type.indexOf('image/') === 0;
    },


    // PDF添付メッセージか否か
    messageIsPdfFile: function messageIsPdfFile(msg) {
      if (msg.type !== 'File') return false;
      if (!msg.content.file) return false;
      if (!msg.content.file.type) return false;

      return msg.content.file.type === 'application/pdf';
    },


    // 添付ファイル取得URL
    createFileURL: function createFileURL(msg) {
      if (msg.type !== 'File') return '';

      var roomId = msg.content.room_id;
      var fileId = msg.content.file_id;
      var accessToken = msg.content.access_token;
      return this.$options.api.getRoomFileURL(roomId, fileId, accessToken);
    },


    // 添付ファイルサイズ表示文字列
    toFileSizeString: function toFileSizeString(size) {
      var units = ['K', 'M', 'G', 'T'];
      var currentUnit = '';
      var currentSize = size;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(units), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var unit = _step2.value;

          var nextSize = Math.floor(currentSize / 1000);
          if (nextSize <= 0) break;

          currentSize = nextSize;
          currentUnit = unit;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return currentSize + ' ' + currentUnit + 'Bytes';
    },
    latestMessage: function latestMessage() {
      return this.messages[this.messages.length - 1];
    },
    isMessageHead: function isMessageHead(message) {
      return this.latestMessage().id == message.id;
    },
    toNewChat: function toNewChat() {
      console.log(this.room);
      this.$emit("toNewChat");
    },
    callOperator: function callOperator(event) {
      if (this.$options.chatClient.isWaitingResponse) return;
      var label = event.target.innerText;
      this.$emit("set-message-loading", true);
      this.$options.chatClient.sendOperatorCall(label, this.room);
    },


    // FAQデータ「次の5件」を追加表示
    onClickNextFaqButton: function onClickNextFaqButton(event) {
      var _this5 = this;

      var index = this.messages.length - 1;
      var target = __WEBPACK_IMPORTED_MODULE_3_jquery__(event.target).parents('.displayFaq');
      var faqAnswers = target.parent().find(".answerData").children();
      var defaultStyle = target.find('.nextFaq').attr('style');
      var height = __WEBPACK_IMPORTED_MODULE_3_jquery__(this.$refs.root).prop('offsetHeight');
      this.messages[index].content.faqIsLoading = true;
      // アニメーション表示時に高さがずれないように高さを指定する
      target.find('.card').css('height', height);
      // アニメーション終了後、ボタン「次の5件」を非活性にした後に次のFAQを5件表示する
      var wait = function wait(seconds) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          setTimeout(resolve, seconds);
        });
      };
      wait(LOADING_TIME).then(function () {
        _this5.messages[index].content.faqIsLoading = false;
        target.find('.nextFaq').prop("disabled", true);
        target.find('.nextFaq').css({ 'cssText': 'color: rgba(0,0,0,.26); background-color: rgba(0,0,0,.12) !important; box-shadow: none !important;' });
        return wait(NEXT_FAQ_TIME);
      }).then(function () {
        target.find('.nextFaq').prop("disabled", false);
        target.find('.nextFaq').css({ 'cssText': defaultStyle });
        faqAnswers.each(function (index) {
          if (faqAnswers.length == (index += 1)) {
            target.hide();
          }
          if (__WEBPACK_IMPORTED_MODULE_3_jquery__(this).css('display') == 'none') {
            __WEBPACK_IMPORTED_MODULE_3_jquery__(this).show();
            return false;
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "FQ6K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h4', [_vm._v("パスワード変更")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form"
  }, [_c('v-text-field', {
    attrs: {
      "label": "現在のパスワード",
      "required": "",
      "type": "password",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.currentPassword),
      callback: function($$v) {
        _vm.currentPassword = $$v
      },
      expression: "currentPassword"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "新しいパスワード",
      "required": "",
      "type": "password",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "新しいパスワード（確認）",
      "required": "",
      "type": "password",
      "rules": _vm.passwordRetypeRules
    },
    model: {
      value: (_vm.newPasswordRetype),
      callback: function($$v) {
        _vm.newPasswordRetype = $$v
      },
      expression: "newPasswordRetype"
    }
  })], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "warning": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.errMessage)
    },
    model: {
      value: (_vm.visibleErrMessage),
      callback: function($$v) {
        _vm.visibleErrMessage = $$v
      },
      expression: "visibleErrMessage"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("変更")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "error": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fn/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.kindMaster), function(kind) {
    return _c('div', {
      key: kind.kind_id
    }, [_c('v-subheader', {
      domProps: {
        "textContent": _vm._s(kind.kind_name)
      }
    }), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.productMaster), function(product) {
      return (product.kind_id === kind.kind_id) ? _c('v-flex', {
        key: product.product_id,
        attrs: {
          "xs12": "",
          "sm6": "",
          "md4": "",
          "lg": "",
          "3": "",
          "xl2": ""
        }
      }, [_c('v-checkbox', {
        attrs: {
          "label": product.product_name
        },
        model: {
          value: (product.selected),
          callback: function($$v) {
            product.selected = $$v
          },
          expression: "product.selected"
        }
      })], 1) : _vm._e()
    }))], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_const__ = __webpack_require__("6d20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BaseComponent__ = __webpack_require__("q0ey");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_BaseComponent__["a" /* default */],
  data: function data() {
    return {
      visibleDrawer: false
    };
  },

  computed: {
    title: function title() {
      return __WEBPACK_IMPORTED_MODULE_0__util_const__["a" /* default */].title;
    },
    subTitle: function subTitle() {
      return __WEBPACK_IMPORTED_MODULE_0__util_const__["a" /* default */].subTitle;
    },
    enabledMenu: function enabledMenu() {
      var name = this.$route.name;
      return name !== 'Top' && name !== 'UserReg';
    }
  },
  methods: {
    toChat: function toChat() {
      this.$router.push({ name: 'Chat' });
      this.visibleDrawer = false;
    },
    toNewChat: function toNewChat() {
      this.setCurrentRoom(null);
      this.$router.push({ name: 'Chat' });
      this.visibleDrawer = false;
    },
    toProfile: function toProfile() {
      this.$router.push({ name: 'Profile' });
      this.visibleDrawer = false;
    },
    toPasswordChange: function toPasswordChange() {
      this.$router.push({ name: 'PasswordChange' });
      this.visibleDrawer = false;
    },
    toTop: function toTop() {
      this.setCurrentRoom(null);
      this.$router.push({ name: 'Top' });
    }
  }
});

/***/ }),

/***/ "I4vE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I8UB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    attrs: {
      "absolute": "absolute",
      "temporary": "temporary",
      "light": "light",
      "overflow": "overflow"
    },
    model: {
      value: (_vm.visibleDrawer),
      callback: function($$v) {
        _vm.visibleDrawer = $$v
      },
      expression: "visibleDrawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.currentUser !== null) ? _c('v-list-tile', {
    on: {
      "click": _vm.toChat
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("チャット")])], 1)], 1) : _vm._e(), (_vm.viewNewChatFlg === true) ? _c('v-list-tile', {
    on: {
      "click": _vm.toNewChat
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("新しいチャットを開始")])], 1)], 1) : _vm._e(), _c('v-divider')], 1)], 1), _c('v-toolbar', {
    staticClass: "white",
    attrs: {
      "dark": "dark",
      "fixed": "fixed"
    }
  }, [(_vm.enabledMenu) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.visibleDrawer = !_vm.visibleDrawer
      }
    }
  }) : _vm._e(), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _c('v-spacer'), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/user/static/logo.png"
    }
  })], 1), _c('div', {
    staticClass: "border"
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_room__ = __webpack_require__("IeLu");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  strict: true,
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    room: __WEBPACK_IMPORTED_MODULE_3__modules_room__["a" /* default */]
  }
}));

/***/ }),

/***/ "IeLu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var state = {
  room: JSON.parse(localStorage.getItem('room')),
  viewNewChatFlg: JSON.parse(localStorage.getItem('viewNewChatFlg'))
};

var mutations = {
  onUpdateCurrentRoom: function onUpdateCurrentRoom(state, room) {
    state.room = room;
    localStorage.setItem('room', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(room));
  },
  onUpdateViewNewChatFlg: function onUpdateViewNewChatFlg(state, reload) {
    state.viewNewChatFlg = reload;
    localStorage.setItem('viewNewChatFlg', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reload));
  }
};

var actions = {
  setCurrentRoom: function setCurrentRoom(context, room) {
    var newRoom = !room ? null : {
      id: room.roomId,
      accessToken: room.roomAccessToken
    };
    context.commit('onUpdateCurrentRoom', newRoom);
  },
  setViewNewChatFlg: function setViewNewChatFlg(context, reload) {
    context.commit('onUpdateViewNewChatFlg', reload);
  }
};

var getters = {
  currentRoom: function currentRoom(state) {
    return state.room;
  },
  chatEnabled: function chatEnabled(state) {
    return state.chatEnabled;
  },
  viewNewChatFlg: function viewNewChatFlg(state) {
    return state.viewNewChatFlg;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "LDsl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h4', [_vm._v(_vm._s(this.title))])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ユーザーID（メールアドレス）",
      "required": "",
      "rules": _vm.requiredFieldRules,
      "disabled": _vm.currentUser !== null
    },
    model: {
      value: (_vm.userId),
      callback: function($$v) {
        _vm.userId = $$v
      },
      expression: "userId"
    }
  }), _vm._v(" "), (_vm.currentUser === null) ? _c('div', [_c('v-text-field', {
    attrs: {
      "label": "パスワード",
      "required": "",
      "type": "password",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "パスワード（確認）",
      "required": "",
      "type": "password",
      "rules": _vm.passwordRetypeRules
    },
    model: {
      value: (_vm.passwordRetype),
      callback: function($$v) {
        _vm.passwordRetype = $$v
      },
      expression: "passwordRetype"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "姓",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "姓（かな）",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.lastNameKana),
      callback: function($$v) {
        _vm.lastNameKana = $$v
      },
      expression: "lastNameKana"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "名",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "名（かな）",
      "required": "",
      "rules": _vm.requiredFieldRules
    },
    model: {
      value: (_vm.firstNameKana),
      callback: function($$v) {
        _vm.firstNameKana = $$v
      },
      expression: "firstNameKana"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h6', [_vm._v("お持ちの製品を選択してください。")]), _vm._v(" "), _c('product-select', {
    ref: "productSelect",
    on: {
      "load-master": _vm.onLoadProductMaster
    }
  }), _vm._v(" "), _c('v-alert', {
    attrs: {
      "warning": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.errMessage)
    },
    model: {
      value: (_vm.visibleErrMessage),
      callback: function($$v) {
        _vm.visibleErrMessage = $$v
      },
      expression: "visibleErrMessage"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "indigo--text darken-2",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.saveBtnLabel) + "\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-2",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a8f984_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("CQE+");
function injectStyle (ssrContext) {
  __webpack_require__("xmlW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a8f984_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MnUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PromiseProxy__ = __webpack_require__("SPwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LongPolling__ = __webpack_require__("5ZFJ");






/**
 * ルーム関連
 */

var Api = function () {
  function Api() {
    var authToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.authToken = authToken;
    this._axiosInstance = null;
    this._sessionExpiredHandler = null;
    this._roomToken = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'login',


    /*
     * ログイン
     */
    value: function login(userId, password) {
      var login = this.request('POST', '/login', {
        data: {
          user_id: userId,
          passwd: password
        }
      });
      return login;
    }

    /*
     * ログアウト
     */

  }, {
    key: 'logout',
    value: function logout() {
      return this.request('POST', '/logout');
    }

    /*
     * オペレーター状態更新
     */

  }, {
    key: 'updateOpState',
    value: function updateOpState(newState) {
      return this.request('PUT', '/operator/state', {
        data: newState
      });
    }

    /*
     * オペレーター一覧取得
     */

  }, {
    key: 'getOperators',
    value: function getOperators() {
      return this.request('GET', '/operators');
    }

    /*
    * チャット対応可能なオペレータがいるかをステータスコードで返却
    */

  }, {
    key: 'getSeatedOperators',
    value: function getSeatedOperators(roomId) {
      return this.request('GET', '/operators/seated/' + roomId);
    }

    /*
     * ルーム一覧取得
     */

  }, {
    key: 'getRooms',
    value: function getRooms(params) {
      var req_params = {};
      if (params.todayOnly) {
        req_params['today_only'] = 1;
      }
      if (params.minDate) {
        req_params['min_date'] = params.minDate;
      }
      if (params.maxDate) {
        req_params['max_date'] = params.maxDate;
      }
      if (params.pageNum) {
        req_params['page_num'] = params.pageNum;
      }
      if (params.pageRowCount) {
        req_params['page_row_count'] = params.pageRowCount;
      }

      return this.request('GET', '/rooms', {
        params: req_params
      });
    }

    /*
     * id配列によるルーム一覧取得
     */

  }, {
    key: 'getRoomsById',
    value: function getRoomsById(ids) {
      return this.request('GET', '/rooms', {
        params: {
          ids: ids.join(',')
        }
      });
    }

    /*
     * ログイン中オペレーターが対応中のルーム一覧取得
     */

  }, {
    key: 'getOpRespondingRooms',
    value: function getOpRespondingRooms() {
      return this.request('GET', '/rooms/op-responding');
    }

    /*
     * ユーザーがアクセスしたルームの状態を取得
     */

  }, {
    key: 'currentRoomStatus',
    value: function currentRoomStatus(roomId) {
      return this.request('GET', '/rooms/state/' + roomId);
    }

    /**
     * 新規ルーム作成
     */

  }, {
    key: 'createRoom',
    value: function createRoom() {
      return this.request('POST', '/rooms');
    }

    /**
       * 既存ルーム取得
       *
       * @param roomId 取得するルームID
       * @param accessToken ルーム認証トークン
       */

  }, {
    key: 'getRoom',
    value: function getRoom(roomId) {
      return this.request('GET', '/rooms/' + roomId);
    }

    /**
     * ルームにBotを割り当て
     */

  }, {
    key: 'attachBot',
    value: function attachBot(roomProps) {

      var url = "undefined" + '/bot/instance';
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, roomProps);
    }

    /**
     * チャットルーム内のメッセージ取得
     */

  }, {
    key: 'getRoomMessages',
    value: function getRoomMessages(roomId, sinceId) {

      var params = {};
      if (sinceId !== null) {
        params['since_id'] = sinceId;
      }

      return this.request('GET', '/rooms/' + roomId + '/messages', {
        params: params
      });
    }

    /**
     * チャットルームへメッセージ送信
     */

  }, {
    key: 'sendRoomMessage',
    value: function sendRoomMessage(roomId, message) {

      return this.request('POST', '/rooms/' + roomId + '/messages', {
        data: message,
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'accept': 'application/json; charset=UTF-8'
        }
      });
    }

    /**
     * 既読更新
     */

  }, {
    key: 'updateReadDisplay',
    value: function updateReadDisplay(roomId) {
      var params = {};
      params['type'] = 'user';

      return this.request('POST', '/rooms/' + roomId + '/update-reading-flg', {
        params: params
      });
    }

    /**
     * 既読情報の取得
     */

  }, {
    key: 'getReadMessages',
    value: function getReadMessages(roomId, type) {
      return new __WEBPACK_IMPORTED_MODULE_4__LongPolling__["a" /* default */](this, '/rooms/' + roomId + '/get-read-message/' + type);
    }

    /**
     * 未読表示用新着メッセージ取得
     */

  }, {
    key: 'unreadsendMessage',
    value: function unreadsendMessage(roomId) {
      return this.request('POST', '/room/' + roomId + '/unread-message');
    }

    /*
     * OP・SV間チャットメッセージ取得
     */

  }, {
    key: 'getStaffMessagesLongPolling',
    value: function getStaffMessagesLongPolling(roomId) {
      return new __WEBPACK_IMPORTED_MODULE_4__LongPolling__["a" /* default */](this, '/rooms/' + roomId + '/staff-messages');
    }

    /*
     * OP・SV間チャットメッセージ送信
     */

  }, {
    key: 'sendStaffMessage',
    value: function sendStaffMessage(roomId, message) {
      return this.request('POST', '/rooms/' + roomId + '/staff-messages', {
        data: { message: message }
      });
    }

    /*
     * チャットルーム内にファイル送信
     */

  }, {
    key: 'sendRoomFile',
    value: function sendRoomFile(roomId, file) {
      var formData = new FormData();
      formData.append('file', file);

      return this.request('POST', '/rooms/' + roomId + '/files', {
        data: formData
      });
    }

    /*
     * チャットルーム内のファイル内容取得URL
     */

  }, {
    key: 'getRoomFileURL',
    value: function getRoomFileURL(roomId, fileId, accessToken) {
      // let basePath = `${process.env.CHATSERVICE_URL}/api`
      var basePath = 'https://chat-cs.regza.com/api';
      return basePath + '/rooms/' + roomId + '/files/' + fileId + '?key=' + accessToken;
    }

    /*
     * ルーム状態更新
     */

  }, {
    key: 'updateRoomState',
    value: function updateRoomState(roomId, newState, operatorId) {
      var data = { state: newState };
      if (operatorId !== undefined) {
        data['operator_id'] = operatorId;
      }
      return this.request('PUT', '/rooms/' + roomId + '/state', {
        data: data
      });
    }

    /*
     * Bot応答不能・SV呼出中のルーム状態レコード取得
     */

  }, {
    key: 'getWarningRoomStatesLongPolling',
    value: function getWarningRoomStatesLongPolling() {
      return new __WEBPACK_IMPORTED_MODULE_4__LongPolling__["a" /* default */](this, '/room/warning-states');
    }

    /*
     * ルーム担当割当て
     */

  }, {
    key: 'assignRoom',
    value: function assignRoom(roomId, operatorId) {
      return this.request('POST', '/room/assigns', {
        data: {
          'room_id': roomId,
          'operator_id': operatorId
        }
      });
    }

    /*
     * ルーム担当割当てを承諾
     */

  }, {
    key: 'acceptRoomAssign',
    value: function acceptRoomAssign(assignId) {
      return this.updateRoomAssign(assignId, true);
    }

    /*
     * ルーム担当割当てを拒否
     */

  }, {
    key: 'rejectRoomAssign',
    value: function rejectRoomAssign(assignId) {
      return this.updateRoomAssign(assignId, false);
    }

    /*
     * ルーム担当割当てを承諾/拒否
     */

  }, {
    key: 'updateRoomAssign',
    value: function updateRoomAssign(assignId, accepted) {
      return this.request('PUT', '/room/assigns/' + assignId, {
        data: { accepted: accepted }
      });
    }

    /*
     * 自分に対するルーム割当て取得
     */

  }, {
    key: 'getMyRoomAssigns',
    value: function getMyRoomAssigns(sinceId) {
      var params = {};
      if (sinceId) params['since_id'] = sinceId;
      return this.request('GET', '/room/my-assigns', { params: params });
    }

    /*
     * 自分に対するルーム割当て取得 (ロングポーリング)
     */

  }, {
    key: 'getMyRoomAssignsLongPolling',
    value: function getMyRoomAssignsLongPolling() {
      return new __WEBPACK_IMPORTED_MODULE_4__LongPolling__["a" /* default */](this, '/room/my-assigns');
    }

    /*
     * 単一の質問＆回答候補取得
     */

  }, {
    key: 'getInquiry',
    value: function getInquiry(qid) {
      return this.request('GET', '/inquiries/' + qid);
    }

    /*
     * 質問＆回答候補検索
     */

  }, {
    key: 'searchInquiries',
    value: function searchInquiries(productId, searchWord) {
      return this.request('GET', '/inquiries', {
        params: {
          product_id: productId,
          word: searchWord
        }
      });
    }

    /*
     * 回答に対する次の質問紐付け
     */

  }, {
    key: 'setNextInquiry',
    value: function setNextInquiry(aid, nextQid) {
      return this.request('PUT', '/inquiries/a/' + aid + '/child', {
        data: nextQid
      });
    }

    /*
     * 質問＆回答候補新規作成
     */

  }, {
    key: 'createInquiry',
    value: function createInquiry(params) {
      return this.request('POST', '/inquiries', {
        data: {
          product_id: params.productId,
          text: params.text,
          terminal: params.terminal,
          root: params.root,
          tree_name: params.treeName,
          repair: params.repair,
          repair_cost_num: params.repairCostNum,
          alt_product_id: params.altProductId,
          answers: params.answers
        }
      });
    }

    /*
     * ユーザー一覧取得
     */

  }, {
    key: 'getUsers',
    value: function getUsers() {
      return this.request('GET', '/users');
    }

    /*
     *  ユーザー作成
     */

  }, {
    key: 'createUser',
    value: function createUser(newUser) {
      return this.request('POST', '/users', {
        data: newUser
      });
    }

    /**
     * ユーザー取得
     *
     * @param id ユーザーID (PKもしくはメールアドレス)
     */

  }, {
    key: 'getUser',
    value: function getUser(id) {
      return this.request('GET', '/users/' + id);
    }

    /**
     * ユーザー更新
     *
     * @param id ユーザーID (PKもしくはメールアドレス)
     * @param data 更新データ
     */

  }, {
    key: 'updateUser',
    value: function updateUser(id, data) {
      return this.request('PUT', '/users/' + id, {
        data: data
      });
    }

    /**
     * ユーザー削除
     *
     * @param id ユーザーID (PKもしくはメールアドレス)
     */

  }, {
    key: 'deleteUser',
    value: function deleteUser(id) {
      return this.request('DELETE', '/users/' + id);
    }

    /**
     * エンドユーザー作成
     */

  }, {
    key: 'createEndUser',
    value: function createEndUser(params) {
      return this.request('POST', '/end-users', {
        data: {
          user_id: params.userId,
          passwd: params.password,
          type: 'user',
          first_name: params.firstName,
          first_name_kana: params.firstNameKana,
          last_name: params.lastName,
          last_name_kana: params.lastNameKana,
          owned_product_ids: params.ownedProductIds
        }
      });
    }

    /**
     * エンドユーザープロファイル取得
     */

  }, {
    key: 'getEndUserProfile',
    value: function getEndUserProfile() {
      return this.request('GET', '/end-user/profile');
    }

    /**
     * エンドユーザープロファイル更新
     */

  }, {
    key: 'updateEndUserProfile',
    value: function updateEndUserProfile(params) {
      return this.request('PUT', '/end-user/profile', {
        data: {
          first_name: params.firstName,
          first_name_kana: params.firstNameKana,
          last_name: params.lastName,
          last_name_kana: params.lastNameKana,
          owned_product_ids: params.ownedProductIds
        }
      });
    }

    /**
     * エンドユーザーパスワード変更
     */

  }, {
    key: 'updateEndUserPassword',
    value: function updateEndUserPassword(params) {
      return this.request('PUT', '/end-user/password', {
        data: {
          current: params.currentPassword,
          new: params.newPassword
        }
      });
    }

    /*
     * 修理申込み作成
     */

  }, {
    key: 'createRepairRequest',
    value: function createRepairRequest(data) {
      return this.request('POST', '/repair/requests', {
        data: data
      });
    }

    /*
     * 修理申込み一覧取得
     */

  }, {
    key: 'getRepairRequests',
    value: function getRepairRequests(minDate, maxDate) {
      return this.request('GET', '/repair/requests', {
        params: {
          'min_date': minDate,
          'max_date': maxDate
        }
      });
    }

    /**
     * マスター取得 (プロパティ定義+レコード)
     */

  }, {
    key: 'getMaster',
    value: function getMaster(name) {
      return this.request('GET', '/master/' + name);
    }

    /**
     * マスタープロパティ定義取得
     */

  }, {
    key: 'getMasterProps',
    value: function getMasterProps(name) {
      return this.request('GET', '/master/' + name + '/props');
    }

    /**
     * マスターレコード取得
     */

  }, {
    key: 'getMasterRecords',
    value: function getMasterRecords(name) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var conf = {};
      if (params) {
        conf['params'] = params;
      }
      return this.request('GET', '/master/' + name + '/records', conf);
    }

    /**
     * マスターレコード更新
     */

  }, {
    key: 'updateMasterRecords',
    value: function updateMasterRecords(name, records) {
      return this.request('PUT', '/master/' + name + '/records', {
        data: records
      });
    }

    /**
     * 仕様マスター取得(機種別プロパティ定義+レコード)
     */

  }, {
    key: 'getSpecMaster',
    value: function getSpecMaster(kindId) {
      return this.request('GET', '/master/spec/' + kindId);
    }

    /**
     * 仕様マスター機種別プロパティ定義取得
     */

  }, {
    key: 'getSpecMasterProps',
    value: function getSpecMasterProps(kindId) {
      return this.request('GET', '/master/spec/' + kindId + '/props');
    }

    /**
     * 仕様マスター機種別レコード取得
     */

  }, {
    key: 'getSpecMasterRecords',
    value: function getSpecMasterRecords(kindId) {
      return this.request('GET', '/master/spec/' + kindId + '/records');
    }

    /**
     * 仕様マスター機種別レコード更新
     */

  }, {
    key: 'updateSpecMasterRecords',
    value: function updateSpecMasterRecords(kindId, records) {
      return this.request('PUT', '/master/spec/' + kindId + '/records', {
        data: records
      });
    }

    /**
     * FAQ作成
     *
     * ■送信パラメーター
     * ・title : タイトル (必須)
     * ・content : マークアップを含む内容 (必須)
     * ・kindId : 機種ID (オプショナル)
     * ・productId : 製品型番 (オプショナル)
     */

  }, {
    key: 'createFAQ',
    value: function createFAQ(data) {
      return this.request('POST', '/faq', {
        data: {
          title: data.title,
          content: data.content,
          kind_id: data.kindId,
          product_id: data.productId
        }
      });
    }

    /*
     * FAQ検索
     */

  }, {
    key: 'searchFAQ',
    value: function searchFAQ(condition) {
      var params = {
        word: condition.word,
        kind_id: condition.kindId,
        product_id: condition.productId
      };
      return this.request('GET', '/faq', {
        params: params
      });
    }

    /*
     * FAQ取得
     */

  }, {
    key: 'getFAQ',
    value: function getFAQ(id) {
      return this.request('GET', '/faq/' + id);
    }

    /*
     * FAQ更新
     *
     * ※送信パラメーターは createFAQ と同じ
     */

  }, {
    key: 'updateFAQ',
    value: function updateFAQ(id, data) {
      return this.request('PUT', '/faq/' + id, {
        data: {
          title: data.title,
          content: data.content,
          kind_id: data.kindId,
          product_id: data.productId
        }
      });
    }

    /*
     * FAQ削除
     */

  }, {
    key: 'deleteFAQ',
    value: function deleteFAQ(id) {
      return this.request('DELETE', '/faq/' + id);
    }

    /*
     * 検索語に対し解決したFAQとして登録
     */

  }, {
    key: 'registerResolvedFAQ',
    value: function registerResolvedFAQ(searchWord, id) {
      return this.request('POST', '/faq/resolved', {
        data: {
          search_word: searchWord,
          faq_id: id
        }
      });
    }

    /*
       * APIリクエストを送信します。
       */

  }, {
    key: 'request',
    value: function request(method, url) {
      var exConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


      var config = {
        method: method,
        url: url
      };
      if (exConfig) {
        for (var key in exConfig) {
          config[key] = exConfig[key];
        }
      }

      var promise = this.axiosInstance.request(config);
      return new __WEBPACK_IMPORTED_MODULE_3__PromiseProxy__["a" /* default */](promise, this._sessionExpiredHandler);
    }

    /*
       * 共通設定を定義したaxiosインスタンスを遅延初期化します。
       */

  }, {
    key: 'getBusinessHours',


    /*
    * 現在時刻が営業時間内か外か判定
    */
    value: function getBusinessHours() {
      return this.request('GET', '/room/business-hours');
    }

    /*
    * チャットメッセージ入力中か判定
    */

  }, {
    key: 'enteringCheck',
    value: function enteringCheck(roomId) {
      return this.request('GET', '/room/entering/' + roomId);
    }

    /*
    * 在席時間通知
    */

  }, {
    key: 'postSittingTime',
    value: function postSittingTime(roomId) {
      return this.request('POST', '/room/notice-sittingTime/' + roomId);
    }

    /*
    * roomsテーブル入力中status更新
    */

  }, {
    key: 'userInputCheck',
    value: function userInputCheck(roomId) {
      return this.request('POST', '/room/' + roomId + '/entering-user');
    }
  }, {
    key: 'onSessionExpired',
    set: function set(newHandler) {
      this._sessionExpiredHandler = newHandler;
    }
  }, {
    key: 'roomAccessToken',
    set: function set(newToken) {
      // axiosインスタンスのヘッダー設定を更新するため破棄する。
      this._axiosInstance = null;
      this._roomToken = newToken;
    }
  }, {
    key: 'axiosInstance',
    get: function get() {
      if (!this._axiosInstance) {
        var opts = {
          // baseURL: process.env.CHATSERVICE_URL + '/api',
          baseURL: 'https://chat-cs.regza.com/api',
          headers: {
            'Authorization': this.authToken ? this.authToken : null,
            'X-Room-Authorization': this._roomToken ? this._roomToken : null
          }
        };
        this._axiosInstance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create(opts);
      }
      return this._axiosInstance;
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_polyfill__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// for IE11


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "RiW4":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "SPwt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/*
 * セッション期限切れを検出するcatchを挟み込むためのPromiseラッパー
 */
var PromiseProxy = function () {
  function PromiseProxy(promise, sessionExpiredHandler) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PromiseProxy);

    this.promise = promise;
    this.sessionExpiredHandler = sessionExpiredHandler;
    this.addedSessionExpiredCatch = false;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PromiseProxy, [{
    key: 'then',
    value: function then(handler) {
      this.promise = this.promise.then(handler);
      return this;
    }
  }, {
    key: 'catch',
    value: function _catch(handler) {
      var _this = this;

      if (!this.addedSessionExpiredCatch) {
        this.promise = this.promise.catch(function (err) {
          if (PromiseProxy.sessionExpired(err)) {
            if (_this.sessionExpiredHandler) {
              _this.sessionExpiredHandler();
            } else {
              // pass to next catch
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
            }
          } else {
            // pass to next catch
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
          }
        });
        this.addedSessionExpiredCatch = true;
      }

      this.promise = this.promise.catch(handler);
      return this;
    }
  }], [{
    key: 'sessionExpired',
    value: function sessionExpired(err) {
      if (err.response) {
        var res = err.response;
        var authReq = res.config.headers && res.config.headers['Authorization'] && res.config.headers['Authorization'].length > 0;
        var unauthorized = res.status === 401;
        return authReq && unauthorized;
      }
      return false;
    }
  }]);

  return PromiseProxy;
}();

/* harmony default export */ __webpack_exports__["a"] = (PromiseProxy);

/***/ }),

/***/ "TAaz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TI0G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Api__ = __webpack_require__("MnUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LongPolling__ = __webpack_require__("5ZFJ");





var ChatClient = function () {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ChatClient, null, [{
    key: 'create',


    /*
     * @param authToken 認証トークン
     * @param roomId 接続先ルームID
     * @param roomAccessToken 接続先ルーム認証トークン
     */
    value: function create(authToken, roomId, roomAccessToken) {
      var api = new __WEBPACK_IMPORTED_MODULE_2__Api__["a" /* default */](authToken);
      api.roomAccessToken = roomAccessToken;
      return new ChatClient(api, roomId);
    }

    /**
     * @param api API呼出に使用するApiインスタンス
     * @param roomId 接続するルームID
     */

  }]);

  function ChatClient(api, roomId) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChatClient);

    this.api = api;
    this.roomId = roomId;
    this.messageLongPolling = new __WEBPACK_IMPORTED_MODULE_3__LongPolling__["a" /* default */](api, '/rooms/' + roomId + '/messages');
    this.roomStateLongPolling = new __WEBPACK_IMPORTED_MODULE_3__LongPolling__["a" /* default */](api, '/rooms/' + roomId + '/state');

    this.messageFetchHandler = null;
    this.roomStateFetchHandler = null;
    this.messageErrorHandler = null;
    this.roomStateErrorHandler = null;
    this.isWaitingResponse = false;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ChatClient, [{
    key: 'reset',


    /*
     * ルームID変更してロングポーリングを再起動
     */
    value: function reset(roomId) {
      console.log('Reset chat client: ' + roomId);

      var restartFetchMessage = this.messageLongPolling.isStarted;
      var restartFetchState = this.roomStateLongPolling.isStarted;

      this.stopFetch();

      this.roomId = roomId;
      this.messageLongPolling = new __WEBPACK_IMPORTED_MODULE_3__LongPolling__["a" /* default */](this.api, '/rooms/' + roomId + '/messages');
      this.roomStateLongPolling = new __WEBPACK_IMPORTED_MODULE_3__LongPolling__["a" /* default */](this.api, '/rooms/' + roomId + '/state');

      this.messageLongPolling.onFetch = this.messageFetchHandler;
      this.roomStateLongPolling.onFetch = this.roomStateFetchHandler;

      this.messageLongPolling.onError = this.messageErrorHandler;
      this.roomStateLongPolling.onError = this.roomStateErrorHandler;

      if (restartFetchMessage) {
        this.startFetchMessage();
      }
      if (restartFetchState) {
        this.startFetchRoomState();
      }
    }

    /*
     * ルーム内メッセージ取得開始 (ロングポーリング)
     */

  }, {
    key: 'startFetchMessage',
    value: function startFetchMessage() {
      this.messageLongPolling.start();
    }

    /*
     * ルーム状態取得開始 (ロングポーリング)
     */

  }, {
    key: 'startFetchRoomState',
    value: function startFetchRoomState() {
      this.roomStateLongPolling.start();
    }

    /**
     * ロングポーリングを停止します。
     */

  }, {
    key: 'stopFetch',
    value: function stopFetch() {
      this.messageLongPolling.stop();
      this.roomStateLongPolling.stop();
    }

    /*
     * メッセージ送信
     */

  }, {
    key: 'sendMessage',
    value: function sendMessage(params) {
      return this.sendMessageAs(params, this._sender);
    }
  }, {
    key: 'sendMessageAs',
    value: function sendMessageAs(params, sender) {
      var message = {
        version: '1.0',
        type: params.messageType,
        sender: sender,
        context: params.context,
        content: params.content
      };
      return this.api.sendRoomMessage(this.roomId, message);
    }

    /*
     * Textメッセージ送信
     */

  }, {
    key: 'sendText',
    value: function sendText(text) {
      return this.sendMessage({
        context: 'initial',
        messageType: 'Text',
        content: {
          text: ChatClient.sanitize(text)
        }
      });
    }

    /*
     * 未読表示用Textメッセージ送信
     */

  }, {
    key: 'unreadText',
    value: function unreadText() {
      return this.api.unreadsendMessage(this.roomId);
    }
  }, {
    key: 'sendQuestion',
    value: function sendQuestion(question, category, productCode) {
      this.isWaitingResponse = true;
      return this.sendMessage({
        context: 'question',
        messageType: 'Text',
        content: {
          text: question,
          category: category,
          query: question,
          product_code: productCode
        }
      });
    }
  }, {
    key: 'sendProductCategory',
    value: function sendProductCategory(category) {
      this.isWaitingResponse = true;
      return this.sendMessage({
        context: 'set-product-category',
        messageType: 'Text',
        content: {
          text: ChatClient.sanitize(category.label),
          question_category: category.value
        }
      });
    }
  }, {
    key: 'sendTroubleCategory',
    value: function sendTroubleCategory(troubleCategory, productCategory) {
      this.isWaitingResponse = true;
      return this.sendMessage({
        context: 'set-trouble-category',
        messageType: 'Text',
        content: {
          text: ChatClient.sanitize(troubleCategory.label),
          question_category: troubleCategory.value,
          product_category: productCategory
        }
      });
    }

    /*
     * ButtonListメッセージ送信
     */

  }, {
    key: 'sendButtonList',
    value: function sendButtonList(text, buttonType, buttons) {
      return this.sendMessage({
        context: 'initial',
        messageType: 'ButtonList',
        content: {
          text: ChatClient.sanitize(text),
          type: buttonType,
          buttons: buttons
        }
      });
    }

    /*
     * ButtonClickメッセージ送信
     */

  }, {
    key: 'sendButtonClick',
    value: function sendButtonClick(buttonType, button) {
      return this.sendMessage({
        context: 'initial',
        messageType: 'ButtonClick',
        content: {
          type: buttonType,
          button: button
        }
      });
    }

    /*
     * ProductSelectメッセージ送信
     */

  }, {
    key: 'sendProductSelect',
    value: function sendProductSelect(id, name) {
      return this.sendMessage({
        context: 'product-select',
        messageType: 'ProductSelect',
        content: {
          product_id: id,
          product_name: name
        }
      });
    }

    /*
     * ProductCompareメッセージ送信
     */

  }, {
    key: 'sendProductCompare',
    value: function sendProductCompare(text, products, specs) {
      return this.sendMessage({
        context: 'product-compare',
        messageType: 'ProductCompare',
        content: {
          text: text,
          products: products,
          specs: specs
        }
      });
    }
  }, {
    key: 'sendProductCode',
    value: function sendProductCode(productCode, category) {
      this.isWaitingResponse = true;
      var text = productCode === '' ? 'わからない' : productCode;
      return this.sendMessage({
        context: 'set-product-code',
        messageType: 'Text',
        content: {
          text: text,
          product_code: productCode,
          question_category: category
        }
      });
    }

    /*
     * Textメッセージ送信
     */

  }, {
    key: 'sendAnswerFeedback',
    value: function sendAnswerFeedback(text, isResolved) {
      this.isWaitingResponse = true;
      return this.sendMessage({
        context: 'answer-feedback',
        messageType: 'Text',
        content: {
          text: ChatClient.sanitize(text),
          is_resolved: isResolved
        }
      });
    }

    /*
     * Textメッセージ送信(固定FAQ回答)
     */

  }, {
    key: 'sendAnswerFrequentlyQuestionFeedback',
    value: function sendAnswerFrequentlyQuestionFeedback(text, isResolved) {
      this.isWaitingResponse = true;
      return this.sendMessage({
        context: 'answer-feedback-frequently-question',
        messageType: 'Text',
        content: {
          text: ChatClient.sanitize(text),
          is_resolved: isResolved
        }
      });
    }

    /*
     * オペレータ呼び出しメッセージ送信
     */

  }, {
    key: 'sendOperatorCall',
    value: function sendOperatorCall(text, room) {
      this.api.updateRoomState(room.id, 'bot_hung_up', null);
      this.isWaitingResponse = true;
      return this.sendMessage({
        context: 'call-operator',
        messageType: 'Text',
        content: {
          text: ChatClient.sanitize(text)
        }
      });
    }

    /*
     * Linkメッセージ送信
     */

  }, {
    key: 'sendLink',
    value: function sendLink(text, url, linkText) {
      return this.sendMessage({
        context: 'initial',
        messageType: 'Link',
        content: {
          text: text,
          url: url,
          link_text: linkText
        }
      });
    }

    /**
     * FAQメッセージ送信
     */

  }, {
    key: 'sendFAQ',
    value: function sendFAQ(text, faq) {
      this.sendFAQs(text, [faq]);
    }
  }, {
    key: 'sendRequestFrequentlyFaqChatbot',
    value: function sendRequestFrequentlyFaqChatbot(text, category, troubleCategory) {
      this.isWaitingResponse = true;
      this.sendMessage({
        context: 'request-frequently-faq-chatbot',
        messageType: 'Text',
        content: {
          text: text,
          question_category: category,
          trouble_category: troubleCategory
        }
      });
    }
  }, {
    key: 'sendRequestFaqChatbot',
    value: function sendRequestFaqChatbot(text) {
      this.isWaitingResponse = true;
      this.sendMessage({
        context: 'request-faq-chatbot',
        messageType: 'Text',
        content: {
          text: text
        }
      });
    }

    /**
     * FAQメッセージ送信
     */

  }, {
    key: 'sendFAQs',
    value: function sendFAQs(text, faqs) {
      return this.sendMessage({
        context: 'initial',
        messageType: 'FAQ',
        content: {
          text: text,
          faqs: faqs.map(function (faq) {
            return {
              title: faq.title,
              content: faq.content
            };
          })
        }
      });
    }

    /*
     * Fileメッセージ送信
     */

  }, {
    key: 'sendFile',
    value: function sendFile(fileId, accessToken, file) {
      return this.sendMessage({
        context: 'initial',
        messageType: 'File',
        content: {
          room_id: this.roomId,
          file_id: fileId,
          access_token: accessToken,
          file: {
            name: file.name,
            type: file.type,
            size: file.size
          }
        }
      });
    }
  }, {
    key: 'isClosed',
    value: function isClosed() {
      return this.messageLongPolling.stopRequested || this.roomStateLongPolling.stopRequested;
    }
  }, {
    key: 'sender',
    set: function set(newSender) {
      this._sender = {
        id: newSender.id,
        name: newSender.name,
        role: newSender.role
      };
    }
  }, {
    key: 'onFetchMessage',
    set: function set(handler) {
      this.messageFetchHandler = handler;
      this.messageLongPolling.onFetch = handler;
    }
  }, {
    key: 'onFetchRoomState',
    set: function set(handler) {
      this.roomStateFetchHandler = handler;
      this.roomStateLongPolling.onFetch = handler;
    }
  }, {
    key: 'onErrorMessage',
    set: function set(handler) {
      this.messageErrorHandler = handler;
      this.messageLongPolling.onError = handler;
    }
  }, {
    key: 'onErrorRoomState',
    set: function set(handler) {
      this.roomStateErrorHandler = handler;
      this.roomStateLongPolling.onError = handler;
    }
  }], [{
    key: 'sanitize',
    value: function sanitize(text) {
      if (!text) return '';
      return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96');
    }
  }]);

  return ChatClient;
}();

ChatClient.BOT_USER = {
  "id": 0,
  "name": "bot",
  "role": "bot" };
/* harmony default export */ __webpack_exports__["a"] = (ChatClient);

/***/ }),

/***/ "TfK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: "root"
  }, [_c('chat-messages', {
    attrs: {
      "room": _vm.currentRoom,
      "senderId": _vm.senderId,
      "senderName": _vm.senderName,
      "isAfterBusinessHour": _vm.result.res === _vm.AFTER_BUSINESS_HOURS,
      "senderType": "user",
      "sessionToken": _vm.currentUser ? _vm.currentUser.accessToken : null,
      "messageLoading": _vm.messageLoading,
      "displayVisibilityState": _vm.displayVisibilityState
    },
    on: {
      "view-new-chat": _vm.viewNewChat,
      "enter-room": _vm.onEnterRoom,
      "fetch-new-messages": _vm.onFetchNewMessages,
      "update-messages": _vm.onUpdateMessages,
      "set-product-code": _vm.setProductCode,
      "set-message-loading": _vm.setMessageLoading,
      "chat-is-closed": _vm.onChatClosed,
      "reload-system-state": _vm.reloadSystemState,
      "read-sinceId-clear": _vm.readSinceIdClear,
      "create-notice-timer": _vm.createNoticeTimer,
      "start-polling": _vm.startPolling,
      "stop-polling": _vm.stopPolling,
      "set-business-hours": _vm.exeApiGetBusinessHours
    }
  }), _c('v-card', {
    ref: "input",
    staticClass: "chat-input"
  }, [_c('v-card-actions'), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.result.res === _vm.AFTER_BUSINESS_HOURS) ? _c('v-flex', {
    staticClass: "businessHour",
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("ただいまの時間はオペレーター受付時間外です。")]), _vm._v(" "), _c('p', [_vm._v("（オペレーター受付時間" + _vm._s(_vm.businessHourStart) + "~" + _vm._s(_vm.businessHourEnd) + "）")])]) : _vm._e(), _vm._v(" "), (!_vm.isBotMode() && _vm.result.res !== _vm.AFTER_BUSINESS_HOURS && _vm.op_seated_result === _vm.NOT_SEATED) ? _c('v-flex', {
    staticClass: "operatorNotSeated",
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("ただいま大変込み合っております。")]), _vm._v(" "), _c('p', [_vm._v("ご案内可能になり次第、お繋ぎいたしますのでもう少々お待ちください。")])]) : _vm._e(), _vm._v(" "), (_vm.$options.chatClient && _vm.isClosed) ? _c('v-flex', {
    staticClass: "chatClosed",
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', [_vm._v("このチャットは終了しました。")])]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputText),
      expression: "inputText"
    }],
    ref: "inputText",
    attrs: {
      "placeholder": "入力",
      "rows": "3",
      "disabled": !_vm.isTextAreaActive() || !_vm.freetextAvailable || _vm.isClosed
    },
    domProps: {
      "value": (_vm.inputText)
    },
    on: {
      "focus": _vm.focusUserInputCheck,
      "blur": _vm.blurUserInputCheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "send_btn",
    attrs: {
      "light": "light",
      "disabled": !_vm.isFormSubmittable() || !_vm.freetextAvailable
    },
    on: {
      "click": _vm.sendText
    }
  }, [_vm._v("送信")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "amber",
    attrs: {
      "icon": "icon",
      "dark": "dark",
      "disabled": _vm.isFileSendButtonDisabled() || !_vm.freetextAvailable
    },
    on: {
      "click": _vm.onClickOpenFolder
    }
  }, [_c('v-icon', [_vm._v("folder_open")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(this.entering === _vm.ENTERING) ? _c('v-flex', {
    attrs: {
      "lg10": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "entering"
  }, [_vm._v("オペレーター入力中・・・")])]) : _vm._e()], 1), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "capture": "camera",
      "disabled": !_vm.freetextAvailable
    },
    on: {
      "change": _vm.onChangeFile
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vx5y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BaseComponent__ = __webpack_require__("q0ey");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductSelect',
  extends: __WEBPACK_IMPORTED_MODULE_1__components_BaseComponent__["a" /* default */],
  data: function data() {
    return {
      kindMaster: [],
      productMaster: []
    };
  },

  computed: {
    selectedProductIds: function selectedProductIds() {
      var ids = [];
      if (!this.productMaster) return ids;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.productMaster), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var product = _step.value;

          if (product.selected) {
            ids.push(product.product_id);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ids;
    }
  },
  created: function created() {
    this.loadMaster();
  },

  methods: {
    loadMaster: function loadMaster() {
      var _this = this;

      this.api.getMasterRecords('product-kind').then(function (resKind) {
        _this.kindMaster = resKind.data;

        _this.api.getMasterRecords('product').then(function (resProduct) {
          // チェックボックス用のboolean値を追加
          var products = resProduct.data;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(products), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var product = _step2.value;

              product.selected = false;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this.productMaster = products;
          _this.$emit('load-master');
        }).catch(function (err) {
          _this.handleError('製品マスタの取得に失敗しました。', err);
        });
      }).catch(function (err) {
        _this.handleError('機種マスタの取得に失敗しました。', err);
      });
    },

    // 各製品の選択状態設定
    setSelectedIds: function setSelectedIds(selectedIds) {
      if (!this.productMaster) return;

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.productMaster), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var product = _step3.value;

          product.selected = selectedIds.indexOf(product.product_id) !== -1;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserReg__ = __webpack_require__("5n3p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PasswordChange__ = __webpack_require__("Zcs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Chat__ = __webpack_require__("ePsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Repair__ = __webpack_require__("sxL3");


// import Top from '@/components/Top'





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    // path: '/',
    // name: 'Top',
    // component: Top
    path: '/',
    name: 'Chat',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Chat__["a" /* default */]
  }, {
    path: '/user-reg',
    name: 'UserReg',
    component: __WEBPACK_IMPORTED_MODULE_2__components_UserReg__["a" /* default */]
  },
  // {
  //   path: '/chat',
  //   name: 'Chat',
  //   component: Chat
  // },
  {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_2__components_UserReg__["a" /* default */]
  }, {
    path: '/pw-change',
    name: 'PasswordChange',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PasswordChange__["a" /* default */]
  }, {
    path: '/repair',
    name: 'Repair',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Repair__["a" /* default */],
    props: function props(route) {
      return { initProductId: route.query.productId };
    }
  }]
}));

/***/ }),

/***/ "Zcs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordChange_vue__ = __webpack_require__("h+9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb11461_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordChange_vue__ = __webpack_require__("FQ6K");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordChange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb11461_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordChange_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aCWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSelect_vue__ = __webpack_require__("Vx5y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d001b9f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSelect_vue__ = __webpack_require__("Fn/f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d001b9f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSelect_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b/Hb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("修理お申し込み")]), _c('v-card', [_c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "row"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "xs8",
      "sm9": "sm9",
      "md10": "md10",
      "lg11": "lg11"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "郵便番号",
      "required": "required",
      "rules": _vm.zipCodeRules
    },
    model: {
      value: (_vm.zipCode),
      callback: function($$v) {
        _vm.zipCode = $$v
      },
      expression: "zipCode"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs4": "xs4",
      "sm3": "sm3",
      "md2": "md2",
      "lg1": "lg1"
    }
  }, [_c('v-btn', {
    attrs: {
      "light": "light",
      "disabled": _vm.zipCode === null || _vm.zipCode.length === 0
    },
    on: {
      "click": _vm.searchAddress
    }
  }, [_vm._v("住所検索")])], 1)], 1), _c('v-text-field', {
    attrs: {
      "label": "住所1",
      "required": "required",
      "rules": _vm.address1Rules,
      "counter": _vm.addressMaxLength
    },
    model: {
      value: (_vm.address1),
      callback: function($$v) {
        _vm.address1 = $$v
      },
      expression: "address1"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "住所2 (番地・建物名・号室)",
      "rules": _vm.address2Rules,
      "counter": _vm.addressMaxLength
    },
    model: {
      value: (_vm.address2),
      callback: function($$v) {
        _vm.address2 = $$v
      },
      expression: "address2"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "氏名",
      "required": "required",
      "rules": _vm.nameRules,
      "counter": _vm.nameMaxLength
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "電話番号",
      "required": "required",
      "rules": _vm.telRules
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "製品型番",
      "required": "required",
      "rules": _vm.productIdRules,
      "counter": _vm.productIdMaxLength
    },
    model: {
      value: (_vm.productId),
      callback: function($$v) {
        _vm.productId = $$v
      },
      expression: "productId"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "故障内容など",
      "multi-line": "multi-line",
      "required": "required",
      "rules": _vm.descriptionRules,
      "counter": _vm.descriptionMaxLength
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _c('v-btn', {
    attrs: {
      "primary": "primary",
      "dark": "dark"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("送信")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "lazy": "lazy",
      "persistent": "persistent"
    },
    model: {
      value: (_vm.visibleCompletionDialog),
      callback: function($$v) {
        _vm.visibleCompletionDialog = $$v
      },
      expression: "visibleCompletionDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("修理のお申込みを受け付けました。")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "indigo--text darken-2",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("OK")]), _c('v-spacer')], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ckiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var formatDate = function formatDate(strDate) {
  var date = new Date(strDate);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d = date.getDate();
  return y + '\u5E74' + m + '\u6708' + d + '\u65E5';
};

var formatDateTime = function formatDateTime(strDate) {
  var date = new Date(strDate);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d = date.getDate();
  var h = formatTimeValue(date.getHours());
  var min = formatTimeValue(date.getMinutes());
  var sec = formatTimeValue(date.getSeconds());
  return y + '\u5E74' + m + '\u6708' + d + '\u65E5 ' + h + ':' + min + ':' + sec;
};

var formatTimeValue = function formatTimeValue(val) {
  return val < 10 ? '0' + val : val;
};

/*
 * テキストをHTMLとして解釈不可となるようにエスケープします。
 */
var sanitize = function sanitize(text) {
  if (!text) return '';
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96');
};

/*
 * テキストをサニタイズしてからURLをaタグに、改行文字を<br>に置換します。
 */
var prepareLongTextValue = function prepareLongTextValue(value) {
  if (!value) return '';
  var text = sanitize(value);
  return autoLink(text).split('\n').join('<br>');
};

/*
 * テキスト内URLをaタグに置換します。
 */
var autoLink = function autoLink(value) {
  if (!value) return '';
  return value.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1' target='_blank'>$1</a>");
};

/* harmony default export */ __webpack_exports__["a"] = ({
  formatDate: formatDate,
  formatDateTime: formatDateTime,
  prepareLongTextValue: prepareLongTextValue,
  autoLink: autoLink
});

/***/ }),

/***/ "dLwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_string_prototype_startswith__ = __webpack_require__("Kw+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_string_prototype_startswith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_string_prototype_startswith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BaseComponent__ = __webpack_require__("q0ey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_const__ = __webpack_require__("6d20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_common_vue_src_components_ChatMessages__ = __webpack_require__("AxbB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_common_vue_src_lib_ChatClient__ = __webpack_require__("TI0G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_japanese_string_utils__ = __webpack_require__("GAP4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











// ファイルサイズ制限：10M
var FILE_SIZE_LIMIT = 10 * 1024 * 1024;
var AFTER_BUSINESS_HOURS = 1;
var ENTERING = 1;
var NOT_ENTERING = 0;
var ENTERING_TIME = 2000; // ミリ秒
var RESIZE_TIME = 500; // ミリ秒
var NOTICE_SITTING_TIME = 60000; // ミリ秒
var USER_INPUT_TIME = 3000;
var SEATED = 0;
var NOT_SEATED = 2;
var SEATED_TIME = 120; // 秒
var OPERATION_MODE_BOT = 0; // 無人チャット対応中
var INITIAL_OPERATION_MODE = OPERATION_MODE_BOT;
var OPERATION_MODE_OPERATOR = 1; // 有人チャット対応中
var CHECK_COMMENT_SENDER_OP = ['op', 'sv'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Chat',
  extends: __WEBPACK_IMPORTED_MODULE_2__components_BaseComponent__["a" /* default */],
  components: {
    'chat-messages': __WEBPACK_IMPORTED_MODULE_4__app_common_vue_src_components_ChatMessages__["a" /* default */]
  },
  data: function data() {
    return {
      reSizeTimer: '',
      inputText: '',
      result: {},
      op_seated_result: NOT_SEATED,
      reloadTimer: '',
      reloadTime: 60, // 秒
      businessHourStart: '',
      businessHourEnd: '',
      NOT_SEATED: NOT_SEATED,
      AFTER_BUSINESS_HOURS: AFTER_BUSINESS_HOURS,
      ENTERING: ENTERING,
      NOT_ENTERING: NOT_ENTERING,
      entering: '',
      enteringTimer: '',
      noticeSettingTimer: '',
      seatedTimer: '',
      operationMode: OPERATION_MODE_BOT,
      productCategory: '',
      trourbleCategory: '',
      rawProductCode: '',
      freetextAvailable: false,
      isClosed: false,
      messageLoading: false,
      userInputCheckTimer: '',
      displayVisibilityState: __WEBPACK_IMPORTED_MODULE_3__util_const__["a" /* default */].stateVisible
    };
  },
  // options
  chatClient: null,
  polling: null,

  computed: {
    senderId: function senderId() {
      return this.currentUser ? this.currentUser.id : 'anonymous';
    },
    senderName: function senderName() {
      return this.currentUser ? this.currentUser.name : 'お客様';
    },

    productCode: {
      get: function get() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_japanese_string_utils__["a" /* toAscii */])(this.rawProductCode);
      },
      set: function set(value) {
        console.log(value);
        this.rawProductCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_japanese_string_utils__["a" /* toAscii */])(value);
      }
    }
  },

  mounted: function mounted() {
    this.resizeHeight();
    // visibilitychangeイベントを追加
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },

  created: function created() {
    var _this = this;

    // 営業時間取得のAPIを実行
    this.exeApiGetBusinessHours();

    // 現行のポーリング処理で実装したとしても1～3秒間隔でAPIコールされるため、実装難易度が低いタイマーコールを採用
    // チャットメッセージ入力中確認タイマーセット
    this.createEntringTimer();

    // チャット画面の高さを計算するタイマーセット
    this.reSizeTimer = setInterval(function () {
      _this.onResize();
    }, RESIZE_TIME);

    // 営業時間内だった場合、オペレーターの空き状況を確認
    if (this.result.res !== AFTER_BUSINESS_HOURS) {
      // オペレーターの空き状況チェックAPIを実行
      this.exeApiSeatedOperators();
    }
    this.initialTextInput();
  },

  beforeDestroy: function beforeDestroy() {
    // チャットメッセージ入力中確認タイマー停止
    clearInterval(this.enteringTimer);
    // 営業時間外タイマー停止
    clearInterval(this.reloadTimer);
    // リサイズタイマー停止
    clearInterval(this.reSizeTimer);
    // 在席通知タイマー停止
    clearInterval(this.noticeSettingTimer);
    // 入力中通知タイマー停止
    clearInterval(this.userInputCheckTimer);
    // visibilitychangeイベントを削除
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },

  watch: {
    // 営業時間外の場合の自動リロードタイマー
    reloadTime: function reloadTime(v) {
      if (this.operationMode === OPERATION_MODE_BOT) return;
      if (this.op_seated_result === SEATED) return;
      if (v > 0) return;

      document.location = '/user/';
    },
    displayVisibilityState: function displayVisibilityState(newVal) {
      if (newVal === __WEBPACK_IMPORTED_MODULE_3__util_const__["a" /* default */].stateVisible) {
        // 入力中確認再開
        this.createEntringTimer();
        // 在席通知再開
        this.createNoticeTimer();

        // 既読状態を更新
        this.api.updateReadDisplay(this.currentRoom.id).catch(function (err) {
          console.log(err);
        });
      }

      if (newVal === __WEBPACK_IMPORTED_MODULE_3__util_const__["a" /* default */].stateHidden) {
        // チャットメッセージ入力中確認タイマー停止
        clearInterval(this.enteringTimer);
        // 在席通知タイマー停止
        clearInterval(this.noticeSettingTimer);
        // 入力中通知タイマー停止
        clearInterval(this.userInputCheckTimer);
      }
    },

    // 各タイマーが複数生成されて動作しないようにする制御
    enteringTimer: function enteringTimer(newVal, oldVal) {
      if (oldVal === '') return;
      clearInterval(oldVal);
    },
    userInputCheckTimer: function userInputCheckTimer(newVal, oldVal) {
      if (oldVal === '') return;
      clearInterval(oldVal);
    },
    noticeSettingTimer: function noticeSettingTimer(newVal, oldVal) {
      if (oldVal === '') return;
      clearInterval(oldVal);
    }
  },
  methods: {
    handleVisibilityChange: function handleVisibilityChange() {
      // visibilitychangeイベントで実行される
      this.displayVisibilityState = document.visibilityState;
    },
    exeApiGetBusinessHours: function exeApiGetBusinessHours() {
      var _this2 = this;

      // 営業時間内か営業時間外か確認
      this.api.getBusinessHours().then(function (res) {
        _this2.result = res.data;
        if (_this2.result.res === AFTER_BUSINESS_HOURS) {
          _this2.businessHour = _this2.result.data;
          _this2.businessHourStart = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this2.result.data.business_start_time).utc().format('H:mm');
          _this2.businessHourEnd = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this2.result.data.business_end_time).utc().format('H:mm');
          clearInterval(_this2.reloadTimer);
          _this2.reloadTimer = setInterval(function () {
            _this2.reloadTime--;
          }, 1000);
        }
      }).catch(function (err) {
        _this2.handleError('営業時間の取得に失敗しました', err);
      });
    },
    exeApiSeatedOperators: function exeApiSeatedOperators() {
      var _this3 = this;

      // 在席中のオペレーターがいるか確認
      var paramRoomId = null;
      // ルーム接続中の場合はオペレーターが空いていなくてもIDを渡して再接続させる
      if (this.currentRoom) {
        paramRoomId = this.currentRoom.id;
      }

      this.api.getSeatedOperators(paramRoomId).then(function (res) {
        if (res.data === NOT_SEATED) {
          _this3.op_seated_result = NOT_SEATED;
          _this3.reloadTime = SEATED_TIME;
          // 対応可能になったオペレーターがいないか確認する為のタイマーをセット
          _this3.seatedTimer = setInterval(function () {
            _this3.reloadTime--;
          }, 1000);
        } else {
          // 初期値が混雑なので空いていれば空きに書き換える
          _this3.op_seated_result = SEATED;
        }
      });
    },
    reloadSystemState: function reloadSystemState() {
      this.exeApiGetBusinessHours();
      this.exeApiSeatedOperators();
    },


    // メッセージ既読状態取得ポーリング開始
    startPolling: function startPolling() {
      var _this4 = this;

      if (this.$options.polling !== null) return;
      this.$options.polling = this.api.getReadMessages(this.currentRoom.id, 'user');
      this.$options.polling.onFetch = function (states) {
        return _this4.onMessagesRead(states);
      };
      this.$options.polling.start();
    },


    // 既読情報の取得
    onMessagesRead: function onMessagesRead(res) {
      this.$nextTick(function () {
        if (res.length > 0) {
          res.forEach(function (value, index) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery__('#' + value.id).length) {
              __WEBPACK_IMPORTED_MODULE_0_jquery__('#' + value.id).text('既読');
            }
          });
        }
      });
    },


    // メッセージ既読状態取得ポーリング停止
    stopPolling: function stopPolling() {
      if (this.$options.polling) {
        this.$options.polling.stop();
        this.$options.polling = null;
      }
    },


    // テキストエリアの初期値を設定
    initialTextInput: function initialTextInput() {
      this.inputText = '';
    },

    // チャット画面の高さを計算
    resizeHeight: function resizeHeight() {
      var root = __WEBPACK_IMPORTED_MODULE_0_jquery__(this.$refs.root);
      var input = __WEBPACK_IMPORTED_MODULE_0_jquery__(this.$refs.input);

      var bodyHeight = __WEBPACK_IMPORTED_MODULE_0_jquery__('body').height();
      var top = root.offset().top;
      var inputHeight = input.prop('offsetHeight');

      root.height(bodyHeight - top - inputHeight);
    },


    onEnterRoom: function onEnterRoom(roomProps) {
      this.operationMode = INITIAL_OPERATION_MODE;
      this.setCurrentRoom(roomProps);
      this.isClosed = false;
      var roomId = roomProps.roomId;
      this.$options.chatClient = new __WEBPACK_IMPORTED_MODULE_5__app_common_vue_src_lib_ChatClient__["a" /* default */](this.api, roomId);
      this.freetextAvailable = false;
      this.$options.chatClient.sender = {
        id: this.senderId,
        name: 'お客様',
        role: 'user'
      };
      this.initialTextInput();
    },

    viewNewChat: function viewNewChat(state) {
      // viewNewChatFlgを設定
      // Header.vueの表示制御に使用する
      this.setViewNewChatFlg(state);
    },
    onFetchNewMessages: function onFetchNewMessages(messages) {
      if (messages[messages.length - 1].context !== 'question') {
        this.setMessageLoading(false);
      }

      // 最新のBotメッセージに応じた処理
      var botMessages = messages.filter(function (message) {
        return message.sender.role === 'bot';
      });
      if (botMessages.length !== 0) {
        var latestBotMessage = botMessages[botMessages.length - 1];
        console.log('freetext: ' + latestBotMessage.content.freetext_processible);
        this.freetextAvailable = latestBotMessage.content.freetext_processible;
      }

      if (this.op_seated_result === NOT_SEATED) {
        // OPの在籍の確認ができていない場合
        if (messages.filter(function (message) {
          return CHECK_COMMENT_SENDER_OP.includes(message.sender.role);
        }).length > 0) {
          // OP,SVの発言が確認できれば、在籍確認結果を更新する
          this.op_seated_result = SEATED;
        }
      }

      if (messages.filter(function (message) {
        return message.context === 'call-operator';
      }).length > 0) {
        this.operationMode = OPERATION_MODE_OPERATOR;
      }

      // 修理申込みへ遷移
      if (!messages.length === 1) return;
      var newMessage = messages[0];
      if (newMessage.type !== 'ButtonClick') return;

      var btn = newMessage.content.button;
      if (!btn.value.startsWith) return;
      if (!btn.value.startsWith('request_repair:')) return;

      var splited = btn.value.split(':');
      if (splited.length < 2) return;

      var productId = splited[1];
      this.$router.push({ path: '/repair?productId=' + productId });
    },
    onUpdateMessages: function onUpdateMessages(containerHeight) {
      __WEBPACK_IMPORTED_MODULE_0_jquery__(this.$refs.root).animate({ scrollTop: containerHeight });
    },

    sendText: function sendText() {
      if (!this.$options.chatClient) {
        return;
      }

      if (this.operationMode === OPERATION_MODE_BOT) {
        var category = '' + this.productCategory;
        this.setMessageLoading(true);
        this.$options.chatClient.sendQuestion(this.inputText, category, this.productCode);
      } else {
        this.$options.chatClient.sendText(this.inputText);
        this.$options.chatClient.unreadText();
      }
      this.inputText = '';
    },
    onClickOpenFolder: function onClickOpenFolder() {
      this.$refs.fileInput.click();
    },
    onChangeFile: function onChangeFile(e) {
      var _this5 = this;

      if (e.target.files.length === 0) return;

      var roomId = this.currentRoom.id;
      var file = e.target.files[0];

      if (FILE_SIZE_LIMIT < file.size) {
        alert('ファイルサイズが大きすぎます。');
        return;
      }

      this.api.sendRoomFile(roomId, file).then(function (res) {
        if (_this5.$options.chatClient) {
          var fileId = res.data.id;
          var accessToken = res.data.access_token;
          var sendMsg = _this5.$options.chatClient.sendFile(fileId, accessToken, file);
          sendMsg.then(function (res) {
            _this5.$refs.fileInput.value = null;
          }).catch(function (err) {
            _this5.handleError('ファイルの送信に失敗しました。', err);
          });
        }
      }).catch(function (err) {
        _this5.handleError('ファイルの送信に失敗しました。', err);
      });
    },


    // 入力中状態取得タイマー作成
    createEntringTimer: function createEntringTimer() {
      var _this6 = this;

      this.enteringTimer = setInterval(function () {
        _this6.onEntring();
      }, ENTERING_TIME);
    },


    // 入力中statusの取得
    onEntring: function onEntring() {
      var _this7 = this;

      this.api.enteringCheck(this.currentRoom.id).then(function (res) {
        _this7.entering = res.data;
      }).catch(function (err) {
        _this7.handleError('ネットワークが不安定な為、通信に時間がかかっています。', err);
      });
    },


    // 在席通知タイマー作成
    createNoticeTimer: function createNoticeTimer() {
      var _this8 = this;

      // 初回読込時用
      this.onNoticeSetting();
      // タイマー作成
      this.noticeSettingTimer = setInterval(function () {
        _this8.onNoticeSetting();
      }, NOTICE_SITTING_TIME);
    },


    // サーバーに在席状況を送信する
    onNoticeSetting: function onNoticeSetting() {
      var _this9 = this;

      this.api.postSittingTime(this.currentRoom.id).catch(function (err) {
        _this9.handleError('ネットワークが不安定な為、通信に時間がかかっています。', err);
      });
    },
    onChatClosed: function onChatClosed() {
      var _this10 = this;

      console.log('Closing');
      this.$nextTick(function () {
        return _this10.isClosed = true;
      });
      this.stopPolling();
    },
    setProductCode: function setProductCode(code) {
      this.productCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_japanese_string_utils__["a" /* toAscii */])(code);
    },
    setMessageLoading: function setMessageLoading(value) {
      this.messageLoading = value;
    },
    onResize: function onResize() {
      this.resizeHeight();
    },


    // メッセージ入力欄がフォーカスされた場合に入力中と判断
    focusUserInputCheck: function focusUserInputCheck() {
      var _this11 = this;

      this.userInputCheckTimer = setInterval(function () {
        _this11.onUserInputSetting();
      }, USER_INPUT_TIME);
    },
    onUserInputSetting: function onUserInputSetting() {
      var _this12 = this;

      this.api.userInputCheck(this.currentRoom.id).catch(function (err) {
        _this12.handleError('ネットワークが不安定な為、通信に時間がかかっています。', err);
      });
    },


    // メッセージ入力欄からフォーカスが外れた場合に非入力中と判断
    blurUserInputCheck: function blurUserInputCheck() {
      clearInterval(this.userInputCheckTimer);
    },
    isTextAreaActive: function isTextAreaActive() {
      if (this.$options.chatClient === null) return false;
      if (this.operationMode === OPERATION_MODE_BOT) return true;
      if (this.result.res === AFTER_BUSINESS_HOURS) return false;

      return true;
    },
    isFormSubmittable: function isFormSubmittable() {
      return this.inputText.length !== 0 && this.isTextAreaActive();
    },
    isFileSendButtonDisabled: function isFileSendButtonDisabled() {
      if (this.$options.chatClient === null) return true;
      if (this.operationMode === OPERATION_MODE_BOT) return true;
      if (this.result.res === AFTER_BUSINESS_HOURS) return true;
      if (this.op_seated_result === NOT_SEATED) return true;

      return false;
    },
    isBotMode: function isBotMode() {
      return this.operationMode === OPERATION_MODE_BOT;
    }
  }
});

/***/ }),

/***/ "ePsb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__ = __webpack_require__("dLwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f515c8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__ = __webpack_require__("TfK7");
function injectStyle (ssrContext) {
  __webpack_require__("rHeW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f515c8e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f515c8e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h+9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseComponent__ = __webpack_require__("q0ey");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 必須項目ルール
var requiredRule = function requiredRule(v) {
  return !!v || '必須項目です。';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PasswordChange',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_BaseComponent__["a" /* default */],
  data: function data() {
    return {
      currentPassword: null,
      newPassword: null,
      newPasswordRetype: null,

      requiredFieldRules: [requiredRule],

      errMessage: null,
      visibleErrMessage: false
    };
  },

  computed: {
    passwordRetypeRules: function passwordRetypeRules() {
      var _this = this;

      return [requiredRule, function (v) {
        if (!_this.newPassword) return true;
        if (v === _this.newPassword) return true;

        return 'パスワードが一致しません。';
      }];
    }
  },
  methods: {
    // パスワード変更
    changePassword: function changePassword() {
      var _this2 = this;

      if (!this.$refs.form.validate()) return;

      this.api.updateEndUserPassword({
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }).then(function (res) {
        _this2.$router.go(-1);
      }).catch(function (err) {
        if (err.response && err.response.status === 409) {
          _this2.errMessage = '現在のパスワードが一致しません。';
          _this2.visibleErrMessage = true;
        } else {
          _this2.handleError('パスワードの変更に失敗しました。', err);
        }
      });
    },


    // キャンセル
    cancel: function cancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),

/***/ "he8S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseComponent__ = __webpack_require__("q0ey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProductSelect__ = __webpack_require__("aCWZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// 必須項目ルール
var requiredRule = function requiredRule(v) {
  return !!v || '必須項目です。';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserReg',
  extends: __WEBPACK_IMPORTED_MODULE_0__components_BaseComponent__["a" /* default */],
  components: {
    ProductSelect: __WEBPACK_IMPORTED_MODULE_1__components_ProductSelect__["a" /* default */]
  },
  data: function data() {
    return {
      title: '',
      saveBtnLabel: '',

      userId: null,
      password: null,
      passwordRetype: null,
      firstName: null,
      firstNameKana: null,
      lastName: null,
      lastNameKana: null,

      formValid: true,
      requiredFieldRules: [requiredRule],

      visibleErrMessage: false,
      errMessage: null
    };
  },
  computed: {
    passwordRetypeRules: function passwordRetypeRules() {
      var _this = this;

      return [function (v) {
        if (!_this.password) return true;
        if (v === _this.password) return true;

        return 'パスワードが一致しません。';
      }];
    }
  },
  created: function created() {
    this.title = this.currentUser ? 'プロフィール編集' : '新規ユーザー登録';
    this.saveBtnLabel = this.currentUser ? '保存' : '登録';
  },

  methods: {
    // 製品マスターロード完了時
    onLoadProductMaster: function onLoadProductMaster() {
      if (this.currentUser) {
        this.loadProfile();
      }
    },


    // 現在のプロフィール取得
    loadProfile: function loadProfile() {
      var _this2 = this;

      this.api.getEndUserProfile().then(function (res) {
        _this2.userId = res.data.user_id;
        _this2.firstName = res.data.first_name;
        _this2.firstNameKana = res.data.first_name_kana;
        _this2.lastName = res.data.last_name;
        _this2.lastNameKana = res.data.last_name_kana;

        _this2.$refs.productSelect.setSelectedIds(res.data.owned_product_ids);
      }).catch(function (err) {
        _this2.handleError('ユーザープロフィールの取得に失敗しました。', err);
      });
    },
    save: function save() {
      if (!this.$refs.form.validate()) return;

      if (this.currentUser) {
        this.updateProfile();
      } else {
        this.regUser();
      }
    },


    // プロフィール更新
    updateProfile: function updateProfile() {
      var _this3 = this;

      var update = this.api.updateEndUserProfile({
        firstName: this.firstName,
        firstNameKana: this.firstNameKana,
        lastName: this.lastName,
        lastNameKana: this.lastNameKana,
        ownedProductIds: this.$refs.productSelect.selectedProductIds
      });
      update.then(function (res) {
        _this3.$router.go(-1);
      }).catch(function (err) {
        _this3.handleError('プロフィールの更新に失敗しました。', err);
      });
    },


    // 新規ユーザー登録
    regUser: function regUser() {
      var _this4 = this;

      var create = this.api.createEndUser({
        userId: this.userId,
        password: this.password,
        firstName: this.firstName,
        firstNameKana: this.firstNameKana,
        lastName: this.lastName,
        lastNameKana: this.lastNameKana,
        ownedProductIds: this.$refs.productSelect.selectedProductIds
      });
      create.then(function (res) {
        _this4.login(_this4.userId, _this4.password);
      }).catch(function (err) {
        if (err.response && err.response.status === 409) {
          _this4.errMessage = '\u30E6\u30FC\u30B6\u30FCID ' + _this4.userId + ' \u306F\u3059\u3067\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059\u3002';
          _this4.visibleErrMessage = true;
        } else {
          _this4.handleError('ユーザー登録に失敗しました。', err);
        }
      });
    },


    // キャンセル
    cancel: function cancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),

/***/ "i6Ml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: "chat-messages"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageLoading),
      expression: "messageLoading"
    }]
  }, [_c('img', {
    style: ({
      position: 'absolute',
      top: '40%',
      left: '45%',
      'z-index': '1'
    }),
    attrs: {
      "src": __webpack_require__("pPOJ")
    }
  })]), _vm._l((_vm.messages), function(msg, index) {
    return _c('div', {
      key: msg.id,
      staticClass: "message-root",
      class: _vm.senderType == msg.sender.role ? 'mine' : 'other-user',
      attrs: {
        "data-sender-role": msg.sender.role,
        "data-context": msg.context
      }
    }, [(msg.content.isLoading) ? _c('v-layout', [_c('img', {
      attrs: {
        "src": __webpack_require__("RiW4")
      }
    })]) : _vm._e(), (_vm.loadingDisplayMessageText(msg)) ? _c('v-layout', [(msg.sender.role == 'bot') ? _c('v-icon', {
      staticClass: "op-icon"
    }, [_vm._v("smart_toy")]) : (msg.sender.role != 'user') ? _c('v-icon', {
      staticClass: "op-icon"
    }, [_vm._v("account_circle")]) : _vm._e(), _c('div', {
      staticClass: "sender-name"
    }, [_vm._v(_vm._s(_vm.displaySenderName(msg.sender)))]), _c('div', {
      staticClass: "sender-room-id"
    }, [_vm._v(_vm._s(_vm.displayMessageRoomId(msg.sender.role)))]), _c('div', {
      staticClass: "sender-read",
      attrs: {
        "id": msg.id
      }
    })], 1) : _vm._e(), (_vm.loadingDisplayMessageText(msg)) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), ((msg.type === 'frequentlyQuestionSecond' && _vm.frequentlyQuestionFlg)) ? _c('div', [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('解決した', index)
      },
      attrs: {
        "primary": "primary",
        "elevation": "2",
        "value": "true",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickFrequentlyQuestionAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("解決した")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('他のFAQを調べる', index)
      },
      attrs: {
        "text": "text",
        "value": "false",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickFrequentlyQuestionAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("他のFAQを調べる")])], 1) : _vm._e()]) : (msg.type == 'ButtonList') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, _vm._l((msg.content.buttons), function(btn) {
      return _c('v-btn', {
        key: btn.value,
        attrs: {
          "primary": "primary",
          "dark": "dark",
          "large": "large",
          "data-value": btn.value
        },
        on: {
          "click": function($event) {
            _vm.onClickButton(msg.content.type, btn)
          }
        }
      }, [_vm._v(_vm._s(btn.label))])
    }))]) : (msg.type == 'ButtonClick') ? _c('div', [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(msg.content.button.label))])]) : (msg.type == 'ProductCategorySelect' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, _vm._l((msg.content.categories), function(category) {
      return _c('v-btn', {
        key: category.value,
        class: {
          'button-selected': _vm.isButtonSelected(category.label, index)
        },
        attrs: {
          "large": "large",
          "primary": "primary",
          "data-value": category.value,
          "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
        },
        on: {
          "click": function($event) {
            _vm.onClickProductCategory(category)
          }
        }
      }, [_vm._v(_vm._s(category.label))])
    }))]) : (msg.type == 'TroubleCategorySelect' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, _vm._l((msg.content.categories), function(category) {
      return _c('v-btn', {
        key: category.value,
        class: {
          'button-selected': _vm.isButtonSelected(category.label, index)
        },
        attrs: {
          "large": "large",
          "primary": "primary",
          "data-value": category.value,
          "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
        },
        on: {
          "click": function($event) {
            _vm.onClickTroubleCategory(category)
          }
        }
      }, [_vm._v(_vm._s(category.label))])
    }))]) : (msg.type == 'RequestProductCode' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('v-layout', {
      staticClass: "align-center justify-start row fill-height"
    }, [_c('v-text-field', {
      key: "product-code",
      attrs: {
        "solo": "solo",
        "label": "製品形名",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      model: {
        value: (_vm.productCode),
        callback: function($$v) {
          _vm.productCode = $$v
        },
        expression: "productCode"
      }
    }), _c('v-btn', {
      attrs: {
        "small": "small",
        "primary": "primary",
        "dark": "dark",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickSubmitProductCode()
        }
      }
    }, [_vm._v("次へ")])], 1)], 1) : (msg.type == 'frequentlyQuestion' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "answerData"
    }, [_c('div', {
      staticClass: "answers"
    }, _vm._l((msg.content.answers), function(answers, index) {
      return _c('v-card', {
        key: answers.url,
        attrs: {
          "outlined": "outlined",
          "tile": "tile",
          "link": "link",
          "hover": "hover"
        },
        on: {
          "click": function($event) {
            _vm.onClickAnswerCard(answers)
          }
        }
      }, [_c('v-card-title', [_vm._v(_vm._s(answers.link_text))])], 1)
    }))])]) : (msg.type == 'chatbotFixedMessages' && _vm.frequentlyQuestionFlg) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    })]) : (msg.type == 'Answer' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _vm._l((msg.content.answers), function(answers, index) {
      return _c('div', {
        staticClass: "answerData"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index <= 0),
          expression: "index <= 0"
        }],
        staticClass: "answers",
        attrs: {
          "data-type": msg.content.type
        }
      }, _vm._l((answers), function(answer) {
        return _c('v-card', {
          key: answer.url,
          attrs: {
            "outlined": "outlined",
            "tile": "tile",
            "link": "link",
            "hover": "hover"
          },
          on: {
            "click": function($event) {
              _vm.onClickAnswerCard(answer)
            }
          }
        }, [_c('v-card-title', [_vm._v(_vm._s(answer.link_text))])], 1)
      }))])
    }), (msg.content.answers.length >= 2) ? _c('div', {
      staticClass: "displayFaq"
    }, [_c('v-card', {
      staticClass: "answerFaq"
    }, [_c('v-card-actions', [_c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!msg.content.faqIsLoading),
        expression: "!msg.content.faqIsLoading"
      }]
    }, [_c('v-btn', {
      staticClass: "nextFaq",
      attrs: {
        "primary": "primary",
        "elevation": "2",
        "value": "true",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickNextFaqButton($event)
        }
      }
    }, [_vm._v("次の5件")])], 1), _c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.content.faqIsLoading),
        expression: "msg.content.faqIsLoading"
      }]
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__("RiW4")
      }
    })])], 1)], 1)], 1) : _vm._e(), _c('div', {
      staticClass: "feedback"
    }, [_c('v-card', [_c('v-card-title', [_vm._v("お客様の問題は解決しましたか？　対象がない場合は、あらためてご質問を入力してください。")]), _c('v-card-actions', [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('解決した', index)
      },
      attrs: {
        "primary": "primary",
        "elevation": "2",
        "value": "true",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("解決した")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('解決しなかった', index)
      },
      attrs: {
        "error": "error",
        "elevation": "2",
        "value": "false",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("解決しなかった")])], 1)], 1)], 1)], 2) : (msg.type == 'EndOfFaq' && !msg.content.isLoading) ? _c('div', [(msg.content.no_dispaly_op_call) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")]), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "text",
        "primary": "primary"
      },
      on: {
        "click": function($event) {
          _vm.onClickFaqPageLink()
        }
      }
    }, [_vm._v("FAQサイトにアクセスする ")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('オペレーターによる対応を希望する', index)
      },
      attrs: {
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.callOperator($event)
        }
      }
    }, [_vm._v("オペレーターによる対応を希望する")])], 1)]) : _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")]), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('チャットボットにあらためて質問する', index)
      },
      attrs: {
        "primary": "primary",
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAskChatbot($event)
        }
      }
    }, [_vm._v("チャットボットにあらためて質問する")]), (msg.content.finished) ? _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('オペレーターによる対応を希望する', index)
      },
      attrs: {
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg || _vm.$props.isAfterBusinessHour
      },
      on: {
        "click": function($event) {
          _vm.callOperator($event)
        }
      }
    }, [_vm._v("オペレーターによる対応を希望する")]) : _vm._e()], 1), (msg.content.finished && _vm.$props.isAfterBusinessHour) ? _c('v-btn', {
      attrs: {
        "text": "text",
        "primary": "primary"
      },
      on: {
        "click": function($event) {
          _vm.onClickFaqPageLink()
        }
      }
    }, [_vm._v("FAQサイトにアクセスする ")]) : _vm._e()], 1)]) : (msg.type == 'EndFrequentlyOfFaq' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")])]) : (msg.type == 'Link') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "link"
    }, [_c('a', {
      attrs: {
        "href": msg.content.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(msg.content.link_text))])])]) : (msg.type == 'ProductList') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('v-expansion-panel', {
      staticClass: "product-list"
    }, _vm._l((msg.content.kinds), function(kind) {
      return _c('v-expansion-panel-content', {
        key: kind.id
      }, [_c('div', {
        slot: "header"
      }, [_vm._v(_vm._s(kind.name))]), _c('v-layout', {
        attrs: {
          "row": "row",
          "wrap": "wrap"
        }
      }, _vm._l((kind.products), function(product) {
        return _c('v-flex', {
          key: product.id,
          staticClass: "product-container",
          attrs: {
            "xs12": "xs12",
            "sm6": "sm6",
            "md4": "md4",
            "lg": "lg",
            "3": "3",
            "xl2": "xl2"
          }
        }, [(product.img_url && 0 < product.img_url.length) ? _c('span', [_c('img', {
          staticClass: "product-img",
          attrs: {
            "src": product.img_url
          }
        })]) : _c('span', {
          staticClass: "grey--text darken-2"
        }, [_vm._v("no image")]), _c('v-btn', {
          attrs: {
            "block": "block"
          },
          on: {
            "click": function($event) {
              _vm.onClickProduct(product)
            }
          }
        }, [_vm._v(_vm._s(product.name))])], 1)
      }))], 1)
    }))], 1) : (msg.type == 'ProductSelect') ? _c('div', [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(msg.content.product_name))])]) : (msg.type == 'ProductCompare') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.createProductCompareHeaders(msg.content.products),
        "items": _vm.createProductCompareItems(msg.content.specs),
        "hide-actions": "hide-actions"
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [(props.item.prop_url) ? _c('span', [_c('a', {
            attrs: {
              "href": props.item.prop_url,
              "target": "_blank"
            }
          }, [_vm._v(_vm._s(props.item.prop_name))])]) : _c('span', [_vm._v(_vm._s(props.item.prop_name))])]), _vm._l((msg.content.products), function(product) {
            return _c('td', {
              key: product.product_id,
              staticClass: "text-xs-left"
            }, [_vm._v(_vm._s(props.item[product.product_id]))])
          })]
        }
      }])
    })], 1) : (msg.type == 'SelectOperationMode' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")]), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('チャットボットに質問する', index)
      },
      attrs: {
        "primary": "primary",
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAskFrequentlyFaqChatbot($event)
        }
      }
    }, [_vm._v("チャットボットに質問する")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('オペレーターによる対応を希望する', index)
      },
      attrs: {
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg || _vm.$props.isAfterBusinessHour
      },
      on: {
        "click": function($event) {
          _vm.callOperator($event)
        }
      }
    }, [_vm._v("オペレーターによる対応を希望する")])], 1)]) : (msg.type == 'FAQ') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('v-expansion-panel', _vm._l((msg.content.faqs), function(faq) {
      return _c('v-expansion-panel-content', {
        key: faq.title
      }, [_c('div', {
        staticClass: "faq-title indigo--text darken-4",
        slot: "header"
      }, [_vm._v(_vm._s(faq.title))]), _c('v-card', [_c('v-card-text', {
        domProps: {
          "innerHTML": _vm._s(faq.content)
        }
      })], 1)], 1)
    }))], 1) : (msg.type == 'File') ? _c('div', [(_vm.messageIsImageFile(msg)) ? _c('span', [_c('a', {
      attrs: {
        "href": _vm.createFileURL(msg),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "file-img",
      attrs: {
        "src": _vm.createFileURL(msg)
      }
    })])]) : _c('span', [_c('v-icon', {
      staticClass: "file-icon indigo--text",
      domProps: {
        "textContent": _vm._s(_vm.messageIsPdfFile(msg) ? 'picture_as_pdf' : 'file_download')
      }
    }), _c('a', {
      attrs: {
        "href": _vm.createFileURL(msg),
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "file-size indigo--text"
    }, [_vm._v(_vm._s(msg.content.file.name) + " (" + _vm._s(_vm.toFileSizeString(msg.content.file.size)) + ")")])])], 1)]) : _vm._e()], 1)
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pPOJ":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhMAAwAPU9AAAAAAYGBgsLCw4ODhERERYWFhgYGB8fHyUlJSkpKS8vLzAwMDQ0NDo6Oj8/P0NDQ0ZGRkhISE1NTVJSUlhYWF5eXmRkZGpqamxsbHV1dXt7e4KCgoWFhYuLi46OjpiYmJmZmZ2dnaOjo6Wlpaurq7Gxsba2tri4uL+/v8LCwsbGxsrKys7OztDQ0NXV1dnZ2dzc3OLi4ubm5ujo6Ozs7PHx8fX19ff39yAgIHR0dFdXV5CQkK2trczMzAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/i1NYWRlIGJ5IEtyYXNpbWlyYSBOZWpjaGV2YSAod3d3LmxvYWRpbmZvLm5ldCkAIfkECQoAPQAsAAAAADAAMAAABv/AnnBILBqPyKRyyWw6mbZYqxWzPa/KWAn0AYVKMayYGBNxP+iPKDzG2krddLpkbT9hZzk6BLM/W3lyICAsfkcyVUQsgXqFQ1EybS4WCAcQJkN4emkgfUImEAcIFi5YMAwAqQAFJUI2PJtoPHUlBaoADJ5OGrepDjVCMCJdeSKeNQ69ABpXD8oFpcE8g4M8ui+2vQ9XEMoGL0Q2MCsrMHVCLwbKEFccyhHnSzYRyhxXMs6qByhXKAe3DyJdiaGhwYIKKsSoqKCAgQY2YmoAs1MjnqGLGDMqseFihUCNPWSscGGRyAoJBQYk2FGyjQ0PCQYQkOCoyAsFtwJ4yOghwK3/BeCKuOuVAKIdGQjqGZmgbEBCQyoGKJtgpIIyAjXtsCCgrIKRET5vQZjop0a3nCOM1LgQFgCCFBlTJE0V4AJZIjVE6IigoQXIFhoiUBBxF6Thw4gTE5FhgkdQMS5KmPh4hYSCAAEMbCi8pMYGA5gVkMCSQp2qAB2udGgLwADcJxaUJZjhZEYCZRae2EjWC5oTF9luOWiJhGmvA7qEtBAhwi8ZHMokXBHBGkDuRxxMG+AQL3ZOEVdq5BCgCoLREORVCQBBBEaEsAIyEE9y40QGDCFohMsHMB6NEBhkcMINIM0w1y0IUKZYDzU0oMwvCxbhgTI7RYgXBlIBMAAGnEVYCx8HHJwwn4UkRhgEACH5BAkKAD0ALAMAAwAqACsAAAb/wJ5wSCwWaTSjcslcui4KxaXVrFqFLQVgC1BQr2Cjhcu1hM/CmZbcnRFrLtUKZgPLYnWimg1IuIUuIyAfHyA8MlUuFggHECZFFHwVQy6DIJYgI39KMAxkBSVEKwhkCCtCNCOEq6uPSxp8DjWiFAgIFKdYg6yrIZtFD3wFL0YyiEQou7yFxEoQfAbNVcnLhCDSRRx8EXlVLcqrlyK/RDLBXAcoYDQky5cnTTEaDQsVKmcvIrwgJORKNbPQ9IDB49KHECeSCDxjA0aLFscWSmxiw8WKiBOLrXDRbYWEAgMS7OiWsYcNDwkGFJBw6sWaLQE8lBziIQAZBTC0sUkQY6YM+lJsNkzgM+BeSRUD+EyowIcAi5ksCEgaYZMMhIAZazwjE2BEjQtVASBIMVNICqAAAlyYVUOEjggavpTt0UJDBAoisM7dy7fvRBkmeGA746KECYxMSCgIEMDABr1WamwwwFgBiSopDHDtcKZDWAAGyDIZs9PfkhkJ+JhZYsOBMBdgXBSIRbLIUDYHYBRpIUKEXCExcPCR0ETEZwCrhdjgoBk0B5KkuQQQ0aRGDgFcIPQcEgI7FwEgiMCIUFVAhtpGbpzIgCGEQuXnyDwgSSMEhgwnbmScgZYLAsR71dBALJDx5QEfMvk1RA0YJAXAABgU2Jd6HHBwAnpWBAEAIfkECQoAPQAsAwADACwAKwAABv/AnnBILBZpNKNyyWy6LgrFpdWsWoktBWALUFCv4KWFy7WEz8SZltydoZmymK04S7ABCTfRFpOdXRYIBxAmRRV3FUUmEAcIFi5XMAxkBSVEKwhkCCtEJQVkDDBWGncONZcUCAgUnEM1DncaVg93BS9GMn5FL59sD1YQdwa3Vy8GdxBWHHcRc1c2EXccVjK0XAcoZygHZA+6VTEaDQsVKm8qFQoMGjFnNadvrs7x9PX2RTIqJygu8EM2LlZ8u9fDhooQH0CA+ECinZAVEgoMSLBjnj0VHzIqzCjCz4s1WwJ4IBgDYcaTCU/0WMYmgcN6GFGiDEFjwp0B5uyZkHlSYYz2Q2wIsLiHgqdGEDJGBGADwR89FgmNjnh3YekWBCkI1hixkGerGiJ0RNDwheALERu7nrBIUEkMEyEUjlDBtu2SGTBiOLXbVoYJHsTeuChhYmAVEgoCBDCwYW+VGhsMKFZA4kqKY1wCdDjTweoWA1mrjGmpx0qdO2aa2IDFpgCkKy56kXFQt4hNNgdEYREhoqyQGDjuSLAiwvOW1EJscMBsgIPF0ZlFWKmRQwAXCC97hLDORQAIIjAiWBWQobaRGycyYKC5x1o3izRCYMhw4gbBGZnYIDDMV0iNBqU41l8PHtwx0oBG1IDBAFsMgIGACKLHAQdr0RMEACH5BAkKADgALAMAAwAqACsAAAb/QJxwSCwWaTSjcslcui4KxaXVrFqFLQVgC1BQr2Cjhcu1hM/CmZbcnaGVspitOEuwAQk30RaTgV0WCAcQJkUVdxVFJhAHCBYuVTAMZAUlRCsIZAgrRCUFZAwwTRp3DjWXFAgIFJxDNQ53Gk0PdwUvRjJ+RS+fbA9NEHcGt1cvBncQTRx3EXNXNhF3HE0ytFwHKGcoB2QPukwxGg0LFSpvKhUKDBoxYDWnb67O8fT19k02Livf90QyKy7mrZBQYECCHfPu2fCQYAABCSxwvFizJYCHfkI8BCCz4MUyNgna3ZORiQ2HCXcGmLunYsCdCYfYEIh4jwUBRCM2koEAz16N+WBkAoyocUEnAAQpMOJIURJAgAtzaojQEUHDF6UtNESgIKKn0q9gwwp5gYJHCRX8mMgwwYNYGBspQID4QDfE1SUkFAQIYGCD1yop6Ar+ACKEWyMpjnEJ0AGMjBCDB/NISGQMSD1VVkQeDCKtEBuw2BSAZAXFZsEgDhNByeaAKCItRIi4q2LuaRCvjYgwusXMEBscFBvg4AyG7c1Dl9TIIYALBJFCQjTnIgCEkBslTn9oteTGiQwYQiT5ba2bsxkk5sqVe4JymBlNuSDATCPFiBAheNx9U6PBnQZ/2TADDTf04wEbFolFRA0YuATAABj8JZZ3HHDQ3htBAAAh+QQJCgA9ACwDAAMAKgAtAAAG/8CecEgsFmk0o3LJXLouCsWl1axahS0FYAtQUK9go4XLtYTPwpmW3J2hlbKYrThLsAEJN9EWk4FdFggHECZFFXcVRSYQBwgWLlUwDGQFJUQrCGQIK0QlBWQMME0adw41lxQICBScQzUOdxpND3cFL0YyfkUvn2wPTRB3BrdXLwZ3EE0cdxFzVzYRdxxNMrRcByhnKAdkD7pMMRoNCxUqbyoVCgwaMWA1p2+uzvH09fZNNi4r3/dEMisu5q2QUGBAgh3z7tnwkGAAAQkserxYsyWAh35CPAQgs+DFMjYJ2t2TkYkNhwl3Bpi7p2LAnQmH2BCIeI8FAUQjNpKBAM9ejfZgZAKMqHFBJwAEKTD2SFESQIALp2qI0BFBwxelLTREoCCip9KvYMPWk2GCB7E3LkqY4MeEhIIAAQxs8GqlxgYDcBWQqJLiGJcAHc50MArAQFImY0DqIXLjhpE6d8wssQGLTQFIQ2CYIMHjxNkeLnqRcZCwCEo2B0QJSQECxIcPrQ/3iIHjjoQmIggDkNxDxevfv1v1SPxXRJMaOQRwgSCShgjgwEXogRFBp4AMpY3cOJEBQ4gkQly0hv4bcw8aITBkOOGYHgvX5F/TBNsi/u+rX2c8Jw9Cutil9skWlg0nvAYfCCdk95UNLZQwgggltKCgWEjQEwQAIfkECQoAOQAsAwADACoAKwAABv/AnHBILBZpNKNyyVy6LgrFpdWsWoUtBWALUFCvYKOFy7WEz8KZltydoZWymK04S7ABCTfRFpOBXRYIBxAmRRV3FUUmEAcIFi5VMAxkBSVEKwhkCCtEJQVkDDBNGncONZcUCAgUnEM1DncaTQ93BS9GMn5FL59sD00Qdwa3Vy8GdxBNHHcRc1c2EXccTTK0XAcoZygHZA+6TDEaDQsVKm8qFQoMGjFgNadvrs7x9PX2TTYuK9/3RDIrLuatkFBgQIId8+7Z8JBgAAEJLHK8WLMlgId+QjwEILPgxTI2Cdrdk5GJDYcJdwaYu6diwJ0Jh9gQiHiPBQFEIzaSgQDPXo31YGQEjKhxQScABCkw5khREkCAC6dqiNARQcMXpS00RKAgoqfSr2DhqCjBA4WosEVaiPjA9gOIFAmvuChhgp+SFyDa6k3qboOBAAEUkGBig0RevWxD2GXSwSgAA3yNxAhxGDGIVlXq3DFzt7LlbFZc9CLjIK4QGJ71gliJRYSIq0Ji4LgjYUmNEYjbgjhrg0OvAhwSjiETQASTFbnZlrghBISAoCCIwIigU0AG00NsnADB3e0HEnpsWOuWkEYIDBlOMK/SgkeIECNSJEnTlAsCPfVu0JgRt0aDUl6FpREbF6HlCgYuATAABgGidcMJHHBwAnZVBAEAIfkECQoAOgAsAQADACwAKwAABv9AnXBILBp1NNpxyWwaXReF4tJyWq+6lgLABSiq2LDR0u1axGjhbFv2ztJLWcxWnCXagMSbaIvJxC4WCAcQJkUVeBVFJhAHCBYuVzAMZQUlRCsIZQgrRCUFZQwwVhp4DjWYFAgIFJ1DNQ54GlYPeAUvRjJ/RS+gbQ9WEHgGuFcvBngQVhx4EXRXNhF4HFYytV0HKGIoB2UPu04xGg0LFa5iKhUKDBoxYjVKcEI1z/L2VjYtKCcq4PdWMUh8GPghhIp6/3TIWNGingwRBAmCSJFQhw0PCQYUkODqBIiIA0GEcPfPQ4AyC2DQCAEyoop/MjS12RADhM2WHwzdUzEAzwT6GR8/tjzxjwWBRDVGCI1oE4y9GsLKBBihY8VSiSNQ/UshE0CAC6hsnPhwc6CIURVbaIhAQYRWiyqUijRBsqKTGjFg7LHLt6+RGCdKRILjooQJf05IKDh5YMPbKzU2GAgQQAGJKymQdQnQQUyHk10MUHRCpo0eLHbwnGliI1abAoOtuPBVxgHCIxPwHEA7pIUIEU6FxMCBR4IVEaDN8OGg2QAHhKU3i7BSI4eALhDq6ghxvYsAEERgRAAtIMPtJTdOZMAQIp4QG9e8IVyJIcOJGwlndO2CALHfGg2Y8phfQniAhwcEGlEDBj0BMAAGAyaoQ3occHDCeVYEAQAh+QQFCgA9ACwDAAMAKgArAAAG/8CecEgsFmk0o3LJXLYuCsWl1axahS0FYAtQUK9go4XLtYSXNthK5aoRaVpyd3Yuyngg0Oczcg1nCXIACXRENjEyVjIjeXp7IH5CFYIVRSYQBwgWkUsmj3ugI0k9KwhkCCtEJQVkDDBLMyGgsx8gX6QUCAgUqUM1DoIaSy+OtHsodolFL6xyD8PFxshWLwaCELCyxrW3TTYRghxMKNsfJG5XKAdkD8pKNCSNoCIvZyoVCgwaMVUzJiF6QJB4VadHDRthZLRgEQNhwYcQz9hwscJdRCMyVrhwSEpCgQEJdnC82MOGhwQDCEhg0eNFnC0CPJAc4iEAmQUvNghCwI+kDPlTcjhMEDRAxUwVAwRNmCSHAEuSLAhQGmGTDAR0F2tAkBNghI0LVQEgSDFTSAqgAAJccFNDhI4IGrrNbKEhAgURWMvq3cu3rAwTPOo9dFHChEUmJBQECGBgQ14rNTYYWKyARJUU1rgE6HCmQ1gABsgyGSOHEBhAgsygASanAKcqLpqRcTCyyFA5BwgOaSFChNwYOARJaCLiMwDVQmxwyGyAw0jSmkU0qZFDABcIPYWEsM5FAAgiMCJUFZChtpEbJzJgCDEq+QNBD0bSCIEhw4kbF2eg5YLg8N4aDQjiwGN8eSCITH0RUQMGSQEwAAYE9oUeBxycYJ4VQQAAOw=="

/***/ }),

/***/ "q0ey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_common_vue_src_lib_Api__ = __webpack_require__("MnUI");




/* harmony default export */ __webpack_exports__["a"] = ({
  apiInstance: null,
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUser', 'currentRoom', 'viewNewChatFlg']), {
    api: function api() {
      var _this = this;

      if (this.$options.apiInstance === null) {
        var authToken = this.currentUser ? this.currentUser.accessToken : null;
        this.$options.apiInstance = new __WEBPACK_IMPORTED_MODULE_2__app_common_vue_src_lib_Api__["a" /* default */](authToken);

        if (this.currentRoom) {
          this.$options.apiInstance.roomAccessToken = this.currentRoom.accessToken;
        }

        this.$options.apiInstance.onSessionExpired = function () {
          // セッション期限切れの場合
          _this.setCurrentUser(null);
          _this.$router.push({ name: 'Top' });
        };
      }
      return this.$options.apiInstance;
    }
  }),
  watch: {
    currentUser: function currentUser(newUser) {
      // auth token変更されたらApiインスタンス再作成
      this.$options.apiInstance = null;
    },
    currentRoom: function currentRoom(newRoom) {
      // 現在のルームが変更されたらルーム認証トークンを更新
      if (newRoom !== null && this.$options.apiInstance !== null) {
        this.$options.apiInstance.roomAccessToken = newRoom.accessToken;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setCurrentUser', 'setCurrentRoom', 'setViewNewChatFlg']), {

    // ログイン → チャット画面へ遷移
    login: function login(userId, password) {
      var _this2 = this;

      this.api.login(userId, password, 'user').then(function (res) {
        _this2.setCurrentUser(res.data);
        _this2.$router.push({ name: 'Chat' });
      }).catch(function (err) {
        if (err.response && err.response.status === 401) {
          _this2.errMessage = 'ユーザーIDもしくはパスワードに誤りがあります。';
          _this2.visibleErrMessage = true;
        } else {
          _this2.handleError('ログインに失敗しました。', err);
        }
      });
    },


    // ログアウト → トップ画面へ
    logout: function logout() {
      var _this3 = this;

      this.api.logout().then(function (res) {
        _this3.setCurrentUser(null);
        _this3.setCurrentRoom(null);
        _this3.$router.push({ name: 'Top' });
      }).catch(function (err) {
        _this3.handleError('ログアウトに失敗しました。', err);
      });
    },


    /*
     * 汎用エラーハンドリング
     */
    handleError: function handleError(msg, err) {
      if (true) {
        alert(msg);
      } else {
        console.log(err);
        alert(msg + ' (' + err + ')');
      }
    }
  })
});

/***/ }),

/***/ "rHeW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sxL3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repair_vue__ = __webpack_require__("50TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d44d27a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Repair_vue__ = __webpack_require__("b/Hb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repair_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d44d27a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Repair_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa64c7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("I8UB");
function injectStyle (ssrContext) {
  __webpack_require__("I4vE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fa64c7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa64c7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__("teIl");

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'header-nav': __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['currentUser'])),
  created: function created() {
    var _this = this;

    if (!this.currentUser) {
      this.$router.push({ name: 'Top' });
    }
    this.$router.beforeEach(function (to, from, next) {
      _this.guardRoute(to, from, next);
    });
  },

  methods: {
    // グローバルルーティングガード
    guardRoute: function guardRoute(to, from, next) {
      if (to.name === 'Top') {
        if (this.currentUser) {
          next({ name: 'Chat' });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  }
});

/***/ }),

/***/ "xmlW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3d9c66c45ac3a8b8da50.js